import { klwAxios, mock } from "helpers/api";

export const MOCK_PERCELEN = {
  gekoppeldeGewaspercelen: [
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1534,
      gewascodeOmschrijving: "Grasland, blijvend",
      gewasCodeRvo: "265",
      gewasPerceelId: "RVO27378529CFD0000000279557",
      grondsoort: "Veen",
      grondsoortcategorieId: 1,
      grondwatertrap: "II",
      handmatig: false,
      isGemonsterd: true,
      klaverPercentage: 0,
      monsters: [
        {
          monsterId: "85@erger",
          laboratoriumCode: "BLGG",
          laboratoriumNaam: "Eurofins Agro",
          pal: 1,
          pw: 1,
          ppae: 1,
          monsterDatum: "2019-08-20T00:00:00",
          monsterNaam: "rewtfre",
          soc: 1,
          organischeStof: 1,
          lutum: 1,
          cnRatio: 1,
        },
      ],
      rvoObjectId: 1501795,
      oppervlakte: 1.61,
      pal: 1,
      perceelId: 10930,
      perceelNaam: "11 hond",
      ppae: 1,
      pw: 1,
      fosfaatklasseBepalingMethode: 1,
      fosfaatklasseBepalingMethodeKiesbaar: true,
      magDoorgerekendWorden: true,
      soc: 1.512031,
      organischeStof: 36.05999965667725,
      lutum: 4.53,
      cnRatio: 40,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1534,
      gewascodeOmschrijving: "Grasland, blijvend",
      gewasCodeRvo: "265",
      gewasPerceelId: "RVO27378529CFD0000001997369",
      grondsoort: "Klei",
      grondsoortcategorieId: 2,
      grondwatertrap: "II",
      handmatig: false,
      isGemonsterd: true,
      klaverPercentage: 0,
      monsters: [
        {
          monsterId: "86@test",
          laboratoriumCode: "BLGG",
          laboratoriumNaam: "Eurofins Agro",
          pal: 3,
          pw: 3,
          ppae: 3,
          monsterDatum: "2019-08-04T00:00:00",
          monsterNaam: "test",
        },
      ],
      rvoObjectId: 1680989,
      oppervlakte: 1.06,
      pal: 3,
      perceelId: 10877,
      perceelNaam: "113",
      ppae: 3,
      pw: 3,
      fosfaatklasseBepalingMethode: 1,
      fosfaatklasseBepalingMethodeKiesbaar: true,
      magDoorgerekendWorden: true,
      soc: 1.512031,
      organischeStof: 36.05999965667725,
      lutum: 4.53,
      cnRatio: 40,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1534,
      gewascodeOmschrijving: "Grasland, blijvend",
      gewasCodeRvo: "265",
      gewasPerceelId: "RVO27378529CFD0000001997381",
      grondsoort: "Klei",
      grondsoortcategorieId: 2,
      grondwatertrap: "II",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1204574,
      oppervlakte: 1.57,
      perceelId: 10878,
      perceelNaam: "114",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
      soc: 1.512031,
      organischeStof: 36.05999965667725,
      lutum: 4.53,
      cnRatio: 40,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1534,
      gewascodeOmschrijving: "Grasland, blijvend",
      gewasCodeRvo: "265",
      gewasPerceelId: "RVO27378529CFD0000001997433",
      grondsoort: "Klei",
      grondsoortcategorieId: 2,
      grondwatertrap: "II",
      handmatig: false,
      isGemonsterd: true,
      klaverPercentage: 0,
      monsters: [
        {
          monsterId: "85@erger",
          laboratoriumCode: "BLGG",
          laboratoriumNaam: "Eurofins Agro",
          pal: 1,
          pw: 1,
          ppae: 1,
          monsterDatum: "2019-08-20T00:00:00",
          monsterNaam: "rewtfre",
          soc: 1,
          organischeStof: 1,
          lutum: 1,
          cnRatio: 1,
        },
      ],
      rvoObjectId: 1204573,
      oppervlakte: 1.36,
      pal: 1,
      perceelId: 10879,
      perceelNaam: "115",
      ppae: 1,
      pw: 1,
      fosfaatklasseBepalingMethode: 1,
      fosfaatklasseBepalingMethodeKiesbaar: true,
      magDoorgerekendWorden: true,
      soc: 1.512031,
      organischeStof: 36.05999965667725,
      lutum: 4.53,
      cnRatio: 40,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1534,
      gewascodeOmschrijving: "Grasland, blijvend",
      gewasCodeRvo: "265",
      gewasPerceelId: "RVO27378529CFD0000001997458",
      grondsoort: "Klei",
      grondsoortcategorieId: 2,
      grondwatertrap: "II",
      handmatig: false,
      isGemonsterd: true,
      klaverPercentage: 0,
      monsters: [
        {
          monsterId: "85@erger",
          laboratoriumCode: "BLGG",
          laboratoriumNaam: "Eurofins Agro",
          pal: 1,
          pw: 1,
          ppae: 1,
          monsterDatum: "2019-08-20T00:00:00",
          monsterNaam: "rewtfre",
          soc: 1,
          organischeStof: 1,
          lutum: 1,
          cnRatio: 1,
        },
      ],
      rvoObjectId: 1204572,
      oppervlakte: 1.5,
      pal: 1,
      perceelId: 10880,
      perceelNaam: "116",
      ppae: 1,
      pw: 1,
      fosfaatklasseBepalingMethode: 1,
      fosfaatklasseBepalingMethodeKiesbaar: true,
      magDoorgerekendWorden: true,
      soc: 1.512031,
      organischeStof: 36.05999965667725,
      lutum: 4.53,
      cnRatio: 40,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1536,
      gewascodeOmschrijving: "Grasland, tijdelijk",
      gewasCodeRvo: "266",
      gewasPerceelId: "RVO27378529CFD0000000367402",
      grondsoort: "Klei",
      grondsoortcategorieId: 2,
      grondwatertrap: "II",
      handmatig: false,
      isGemonsterd: true,
      klaverPercentage: 0,
      monsters: [
        {
          monsterId: "86@test",
          laboratoriumCode: "BLGG",
          laboratoriumNaam: "Eurofins Agro",
          pal: 3,
          pw: 3,
          ppae: 3,
          monsterDatum: "2019-08-04T00:00:00",
          monsterNaam: "test",
        },
      ],
      rvoObjectId: 1347118,
      oppervlakte: 1.29,
      pal: 3,
      perceelId: 10881,
      perceelNaam: "1e naast fricadel",
      ppae: 3,
      pw: 3,
      fosfaatklasseBepalingMethode: 1,
      fosfaatklasseBepalingMethodeKiesbaar: true,
      magDoorgerekendWorden: true,
      soc: 1.512031,
      organischeStof: 36.05999965667725,
      lutum: 4.53,
      cnRatio: 40,
    },
    {
      bouwlandcategorieId: 1,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1529,
      gewascodeOmschrijving: "Maïs, snij-",
      gewasCodeRvo: "259",
      gewasPerceelId: "RVO27378529CFD0000000225454",
      grondsoort: "Klei",
      grondsoortcategorieId: 2,
      grondwatertrap: "III",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1615478,
      oppervlakte: 1.26,
      perceelId: 10882,
      perceelNaam: "1e naast huibertweg",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
      soc: 1.512031,
      organischeStof: 36.05999965667725,
      lutum: 4.53,
      cnRatio: 40,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1534,
      gewascodeOmschrijving: "Grasland, blijvend",
      gewasCodeRvo: "265",
      gewasPerceelId: "RVO27378529CFD0000001827677",
      grondsoort: "Klei",
      grondsoortcategorieId: 2,
      grondwatertrap: "IIIb",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1363552,
      oppervlakte: 0.31,
      perceelId: 10883,
      perceelNaam: "2019_Strook_Klei_ArieBassa7",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
      soc: 1.512031,
      organischeStof: 36.05999965667725,
      lutum: 4.53,
      cnRatio: 40,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1536,
      gewascodeOmschrijving: "Grasland, tijdelijk",
      gewasCodeRvo: "266",
      gewasPerceelId: "RVO27378529CFD0000000584572",
      grondsoort: "Klei",
      grondsoortcategorieId: 2,
      grondwatertrap: "II",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1347118,
      oppervlakte: 1.05,
      pal: 3,
      perceelId: 10884,
      perceelNaam: "2e naast fricadel",
      ppae: 3,
      pw: 3,
      fosfaatklasseBepalingMethode: 1,
      fosfaatklasseBepalingMethodeKiesbaar: true,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 1,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1529,
      gewascodeOmschrijving: "Maïs, snij-",
      gewasCodeRvo: "259",
      gewasPerceelId: "RVO27378529CFD0000000667687",
      grondsoort: "Klei",
      grondsoortcategorieId: 2,
      grondwatertrap: "III",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1615478,
      oppervlakte: 1.3,
      perceelId: 10886,
      perceelNaam: "2e naast huibertweg",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
      soc: 1.512031,
      organischeStof: 36.05999965667725,
      lutum: 4.53,
      cnRatio: 40,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1536,
      gewascodeOmschrijving: "Grasland, tijdelijk",
      gewasCodeRvo: "266",
      gewasPerceelId: "RVO27378529CFD0000000289236",
      grondsoort: "Klei",
      grondsoortcategorieId: 2,
      grondwatertrap: "II",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1347118,
      oppervlakte: 1.07,
      pal: 3,
      perceelId: 10895,
      perceelNaam: "3e naast fricadel",
      ppae: 3,
      pw: 3,
      fosfaatklasseBepalingMethode: 1,
      fosfaatklasseBepalingMethodeKiesbaar: true,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 1,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1529,
      gewascodeOmschrijving: "Maïs, snij-",
      gewasCodeRvo: "259",
      gewasPerceelId: "RVO27378529CFD0000000156157",
      grondsoort: "Klei",
      grondsoortcategorieId: 2,
      grondwatertrap: "III",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1615478,
      oppervlakte: 1.3,
      perceelId: 10887,
      perceelNaam: "3e naast huibertweg",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
      soc: 1.512031,
      organischeStof: 36.05999965667725,
      lutum: 4.53,
      cnRatio: 40,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1534,
      gewascodeOmschrijving: "Grasland, blijvend",
      gewasCodeRvo: "265",
      gewasPerceelId: "RVO27378529CFD0000000309047",
      grondsoort: "Klei",
      grondsoortcategorieId: 2,
      grondwatertrap: "III",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1503819,
      oppervlakte: 2.45,
      perceelId: 10888,
      perceelNaam: "achter freek brouwer",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1534,
      gewascodeOmschrijving: "Grasland, blijvend",
      gewasCodeRvo: "265",
      gewasPerceelId: "RVO27378529CFD0000000676314",
      grondsoort: "Klei",
      grondsoortcategorieId: 2,
      grondwatertrap: "III",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1675562,
      oppervlakte: 0.69,
      perceelId: 10889,
      perceelNaam: "achter melkveestal",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1534,
      gewascodeOmschrijving: "Grasland, blijvend",
      gewasCodeRvo: "265",
      gewasPerceelId: "RVO27378529CFD0000000078333",
      grondsoort: "Klei",
      grondsoortcategorieId: 2,
      grondwatertrap: "III",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1501806,
      oppervlakte: 0.49,
      perceelId: 10890,
      perceelNaam: "achter nieuwe stal",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1534,
      gewascodeOmschrijving: "Grasland, blijvend",
      gewasCodeRvo: "265",
      gewasPerceelId: "RVO27378529CFD0000000207830",
      grondsoort: "Klei",
      grondsoortcategorieId: 2,
      grondwatertrap: "II",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1166619,
      oppervlakte: 1.59,
      perceelId: 10891,
      perceelNaam: "achter rolia",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1534,
      gewascodeOmschrijving: "Grasland, blijvend",
      gewasCodeRvo: "265",
      gewasPerceelId: "RVO27378529CFD0000000092061",
      grondsoort: "Klei",
      grondsoortcategorieId: 2,
      grondwatertrap: "III",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1166619,
      oppervlakte: 1,
      perceelId: 10892,
      perceelNaam: "achter rolia huur oma",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1534,
      gewascodeOmschrijving: "Grasland, blijvend",
      gewasCodeRvo: "265",
      gewasPerceelId: "RVO27378529CFD0000000120121",
      grondsoort: "Veen",
      grondsoortcategorieId: 1,
      grondwatertrap: "II",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1503566,
      oppervlakte: 0.08,
      perceelId: 10893,
      perceelNaam: "achter van iperen tussen pad en wetering",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1534,
      gewascodeOmschrijving: "Grasland, blijvend",
      gewasCodeRvo: "265",
      gewasPerceelId: "RVO27378529CFD0000000363293",
      grondsoort: "Veen",
      grondsoortcategorieId: 1,
      grondwatertrap: "II",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1503566,
      oppervlakte: 0.04,
      perceelId: 10894,
      perceelNaam: "achter van iperen tussen pad en wetering klei",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1534,
      gewascodeOmschrijving: "Grasland, blijvend",
      gewasCodeRvo: "265",
      gewasPerceelId: "RVO27378529CFD0000000311138",
      grondsoort: "Klei",
      grondsoortcategorieId: 2,
      grondwatertrap: "II",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1505930,
      oppervlakte: 2.48,
      perceelId: 10876,
      perceelNaam: "achterkade 2",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1534,
      gewascodeOmschrijving: "Grasland, blijvend",
      gewasCodeRvo: "265",
      gewasPerceelId: "RVO27378529CFD0000000787770",
      grondsoort: "Klei",
      grondsoortcategorieId: 2,
      grondwatertrap: "II",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1614547,
      oppervlakte: 2.46,
      perceelId: 10885,
      perceelNaam: "achterkade 3",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1534,
      gewascodeOmschrijving: "Grasland, blijvend",
      gewasCodeRvo: "265",
      gewasPerceelId: "RVO27378529CFD0000000149961",
      grondsoort: "Klei",
      grondsoortcategorieId: 2,
      grondwatertrap: "II",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1505931,
      oppervlakte: 1.7,
      perceelId: 10875,
      perceelNaam: "achterkade 4",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1534,
      gewascodeOmschrijving: "Grasland, blijvend",
      gewasCodeRvo: "265",
      gewasPerceelId: "RVO27378529CFD0000000009967",
      grondsoort: "Klei",
      grondsoortcategorieId: 2,
      grondwatertrap: "II",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1505932,
      oppervlakte: 1.69,
      perceelId: 10863,
      perceelNaam: "achterkade 5",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1534,
      gewascodeOmschrijving: "Grasland, blijvend",
      gewasCodeRvo: "265",
      gewasPerceelId: "RVO27378529CFD0000000385909",
      grondsoort: "Klei",
      grondsoortcategorieId: 2,
      grondwatertrap: "II",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1505933,
      oppervlakte: 2.84,
      perceelId: 10855,
      perceelNaam: "achterkade manhuis",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1534,
      gewascodeOmschrijving: "Grasland, blijvend",
      gewasCodeRvo: "265",
      gewasPerceelId: "RVO27378529CFD0000000283881",
      grondsoort: "Klei",
      grondsoortcategorieId: 2,
      grondwatertrap: "II",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1501799,
      oppervlakte: 2.12,
      perceelId: 10856,
      perceelNaam: "arie piet achter nieuwbouw",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1536,
      gewascodeOmschrijving: "Grasland, tijdelijk",
      gewasCodeRvo: "266",
      gewasPerceelId: "RVO27378529CFD0000000735180",
      grondsoort: "Veen",
      grondsoortcategorieId: 1,
      grondwatertrap: "III",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1351093,
      oppervlakte: 2.72,
      perceelId: 10857,
      perceelNaam: "arie piet van zuilen noord",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1534,
      gewascodeOmschrijving: "Grasland, blijvend",
      gewasCodeRvo: "265",
      gewasPerceelId: "RVO27378529CFD0000000208908",
      grondsoort: "Veen",
      grondsoortcategorieId: 1,
      grondwatertrap: "II",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1501807,
      oppervlakte: 1.45,
      perceelId: 10858,
      perceelNaam: "arie piet van zuilen wet",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 1,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1529,
      gewascodeOmschrijving: "Maïs, snij-",
      gewasCodeRvo: "259",
      gewasPerceelId: "RVO27378529CFD0000000509072",
      grondsoort: "Veen",
      grondsoortcategorieId: 1,
      grondwatertrap: "II",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 3712538,
      oppervlakte: 3.97,
      perceelId: 10859,
      perceelNaam: "ArieBassa3_pad",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1536,
      gewascodeOmschrijving: "Grasland, tijdelijk",
      gewasCodeRvo: "266",
      gewasPerceelId: "RVO27378529CFD0000000556168",
      grondsoort: "Veen",
      grondsoortcategorieId: 1,
      grondwatertrap: "II",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1303820,
      oppervlakte: 4.67,
      perceelId: 10860,
      perceelNaam: "ArieBassa4",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1536,
      gewascodeOmschrijving: "Grasland, tijdelijk",
      gewasCodeRvo: "266",
      gewasPerceelId: "RVO27378529CFD0000000332941",
      grondsoort: "Klei",
      grondsoortcategorieId: 2,
      grondwatertrap: "IIIb",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1363553,
      oppervlakte: 1.17,
      perceelId: 10861,
      perceelNaam: "ArieBassa6_klei",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1534,
      gewascodeOmschrijving: "Grasland, blijvend",
      gewasCodeRvo: "265",
      gewasPerceelId: "RVO27378529CFD0000001188848",
      grondsoort: "Klei",
      grondsoortcategorieId: 2,
      grondwatertrap: "II",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1363552,
      oppervlakte: 0.3,
      perceelId: 10862,
      perceelNaam: "ArieBassa6_strook_veen",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1536,
      gewascodeOmschrijving: "Grasland, tijdelijk",
      gewasCodeRvo: "266",
      gewasPerceelId: "RVO27378529CFD0000000923826",
      grondsoort: "Klei",
      grondsoortcategorieId: 2,
      grondwatertrap: "IIIb",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1363553,
      oppervlakte: 1.08,
      perceelId: 10864,
      perceelNaam: "ArieBassa6_veen",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1536,
      gewascodeOmschrijving: "Grasland, tijdelijk",
      gewasCodeRvo: "266",
      gewasPerceelId: "RVO27378529CFD0000000645229",
      grondsoort: "Klei",
      grondsoortcategorieId: 2,
      grondwatertrap: "III",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1363552,
      oppervlakte: 1.88,
      perceelId: 10873,
      perceelNaam: "ArieBassa7",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1536,
      gewascodeOmschrijving: "Grasland, tijdelijk",
      gewasCodeRvo: "266",
      gewasPerceelId: "RVO27378529CFD0000000387215",
      grondsoort: "Klei",
      grondsoortcategorieId: 2,
      grondwatertrap: "II",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1347118,
      oppervlakte: 1.29,
      pal: 3,
      perceelId: 10865,
      perceelNaam: "fricadel",
      ppae: 3,
      pw: 3,
      fosfaatklasseBepalingMethode: 1,
      fosfaatklasseBepalingMethodeKiesbaar: true,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1534,
      gewascodeOmschrijving: "Grasland, blijvend",
      gewasCodeRvo: "265",
      gewasPerceelId: "RVO27378529CFD0000000266597",
      grondsoort: "Klei",
      grondsoortcategorieId: 2,
      grondwatertrap: "III",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1615521,
      oppervlakte: 0.17,
      perceelId: 10866,
      perceelNaam: "gastank greta",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1536,
      gewascodeOmschrijving: "Grasland, tijdelijk",
      gewasCodeRvo: "266",
      gewasPerceelId: "RVO27378529CFD0000000105232",
      grondsoort: "Klei",
      grondsoortcategorieId: 2,
      grondwatertrap: "III",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1615766,
      oppervlakte: 2.63,
      perceelId: 10867,
      perceelNaam: "godaert",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 1,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1529,
      gewascodeOmschrijving: "Maïs, snij-",
      gewasCodeRvo: "259",
      gewasPerceelId: "RVO27378529CFD0000000563723",
      grondsoort: "Klei",
      grondsoortcategorieId: 2,
      grondwatertrap: "IIIb",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1505934,
      oppervlakte: 2.1,
      perceelId: 10868,
      perceelNaam: "hagestein manhuis",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1534,
      gewascodeOmschrijving: "Grasland, blijvend",
      gewasCodeRvo: "265",
      gewasPerceelId: "RVO27378529CFD0000000569699",
      grondsoort: "Veen",
      grondsoortcategorieId: 1,
      grondwatertrap: "II",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1501796,
      oppervlakte: 1.03,
      perceelId: 10869,
      perceelNaam: "hassink",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1534,
      gewascodeOmschrijving: "Grasland, blijvend",
      gewasCodeRvo: "265",
      gewasPerceelId: "RVO27378529CFD0000000190526",
      grondsoort: "Veen",
      grondsoortcategorieId: 1,
      grondwatertrap: "II",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1501810,
      oppervlakte: 0.31,
      perceelId: 10870,
      perceelNaam: "hassink voor griend",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1536,
      gewascodeOmschrijving: "Grasland, tijdelijk",
      gewasCodeRvo: "266",
      gewasPerceelId: "RVO27378529CFD0000000187782",
      grondsoort: "Klei",
      grondsoortcategorieId: 2,
      grondwatertrap: "II",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1347118,
      oppervlakte: 1.41,
      pal: 3,
      perceelId: 10871,
      perceelNaam: "jan verhoef 4e",
      ppae: 3,
      pw: 3,
      fosfaatklasseBepalingMethode: 1,
      fosfaatklasseBepalingMethodeKiesbaar: true,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1536,
      gewascodeOmschrijving: "Grasland, tijdelijk",
      gewasCodeRvo: "266",
      gewasPerceelId: "RVO27378529CFD0000000288817",
      grondsoort: "Veen",
      grondsoortcategorieId: 1,
      grondwatertrap: "II",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1615452,
      oppervlakte: 2.24,
      perceelId: 10872,
      perceelNaam: "jan verhoef 5e",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1536,
      gewascodeOmschrijving: "Grasland, tijdelijk",
      gewasCodeRvo: "266",
      gewasPerceelId: "RVO27378529CFD0000000577880",
      grondsoort: "Klei",
      grondsoortcategorieId: 2,
      grondwatertrap: "II",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1347118,
      oppervlakte: 1.44,
      pal: 3,
      perceelId: 10874,
      perceelNaam: "jan verhoef diaconie",
      ppae: 3,
      pw: 3,
      fosfaatklasseBepalingMethode: 1,
      fosfaatklasseBepalingMethodeKiesbaar: true,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1534,
      gewascodeOmschrijving: "Grasland, blijvend",
      gewasCodeRvo: "265",
      gewasPerceelId: "RVO27378529CFD0000000120405",
      grondsoort: "Klei",
      grondsoortcategorieId: 2,
      grondwatertrap: "III",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1501809,
      oppervlakte: 1.16,
      perceelId: 10897,
      perceelNaam: "job + griendje",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1534,
      gewascodeOmschrijving: "Grasland, blijvend",
      gewasCodeRvo: "265",
      gewasPerceelId: "RVO27378529CFD0000001188850",
      grondsoort: "Klei",
      grondsoortcategorieId: 2,
      grondwatertrap: "III",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1501804,
      oppervlakte: 1.4,
      perceelId: 10918,
      perceelNaam: "kk langs huibert",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1534,
      gewascodeOmschrijving: "Grasland, blijvend",
      gewasCodeRvo: "265",
      gewasPerceelId: "RVO27378529CFD0000000748208",
      grondsoort: "Klei",
      grondsoortcategorieId: 2,
      grondwatertrap: "III",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1260207,
      oppervlakte: 1.39,
      perceelId: 10898,
      perceelNaam: "kk naast bonk",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1534,
      gewascodeOmschrijving: "Grasland, blijvend",
      gewasCodeRvo: "265",
      gewasPerceelId: "RVO27378529CFD0000000763616",
      grondsoort: "Klei",
      grondsoortcategorieId: 2,
      grondwatertrap: "III",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1501808,
      oppervlakte: 1.37,
      perceelId: 10921,
      perceelNaam: "kk naast kuilplaat",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1534,
      gewascodeOmschrijving: "Grasland, blijvend",
      gewasCodeRvo: "265",
      gewasPerceelId: "RVO27378529CFD0000000095114",
      grondsoort: "Klei",
      grondsoortcategorieId: 2,
      grondwatertrap: "III",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1260535,
      oppervlakte: 1.32,
      perceelId: 10922,
      perceelNaam: "kk naast oma de jong",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1534,
      gewascodeOmschrijving: "Grasland, blijvend",
      gewasCodeRvo: "265",
      gewasPerceelId: "RVO27378529CFD0000000158138",
      grondsoort: "Klei",
      grondsoortcategorieId: 2,
      grondwatertrap: "III",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1503627,
      oppervlakte: 1.36,
      perceelId: 10923,
      perceelNaam: "kk oma de jong",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1536,
      gewascodeOmschrijving: "Grasland, tijdelijk",
      gewasCodeRvo: "266",
      gewasPerceelId: "RVO27378529CFD0000000382396",
      grondsoort: "Klei",
      grondsoortcategorieId: 2,
      grondwatertrap: "III",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1260319,
      oppervlakte: 1.33,
      perceelId: 10924,
      perceelNaam: "kk rolia",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1534,
      gewascodeOmschrijving: "Grasland, blijvend",
      gewasCodeRvo: "265",
      gewasPerceelId: "RVO27378529CFD0000000103696",
      grondsoort: "Klei",
      grondsoortcategorieId: 2,
      grondwatertrap: "III",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1501802,
      oppervlakte: 1.49,
      perceelId: 10925,
      perceelNaam: "kk tunnis",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1536,
      gewascodeOmschrijving: "Grasland, tijdelijk",
      gewasCodeRvo: "266",
      gewasPerceelId: "RVO27378529CFD0000000517519",
      grondsoort: "Veen",
      grondsoortcategorieId: 1,
      grondwatertrap: "II",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1615452,
      oppervlakte: 1.78,
      perceelId: 10928,
      perceelNaam: "kooikamp",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1536,
      gewascodeOmschrijving: "Grasland, tijdelijk",
      gewasCodeRvo: "266",
      gewasPerceelId: "RVO27378529CFD0000000260163",
      grondsoort: "Klei",
      grondsoortcategorieId: 2,
      grondwatertrap: "II",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1347118,
      oppervlakte: 1.42,
      pal: 3,
      perceelId: 10931,
      perceelNaam: "korte jan verhoef",
      ppae: 3,
      pw: 3,
      fosfaatklasseBepalingMethode: 1,
      fosfaatklasseBepalingMethodeKiesbaar: true,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1536,
      gewascodeOmschrijving: "Grasland, tijdelijk",
      gewasCodeRvo: "266",
      gewasPerceelId: "RVO27378529CFD0000000153072",
      grondsoort: "Klei",
      grondsoortcategorieId: 2,
      grondwatertrap: "II",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 4077345,
      oppervlakte: 1.6,
      perceelId: 10932,
      perceelNaam: "lange achter oma",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1536,
      gewascodeOmschrijving: "Grasland, tijdelijk",
      gewasCodeRvo: "266",
      gewasPerceelId: "RVO27378529CFD0000000248828",
      grondsoort: "Klei",
      grondsoortcategorieId: 2,
      grondwatertrap: "III",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 4077345,
      oppervlakte: 0.73,
      perceelId: 10933,
      perceelNaam: "lange huur oma",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1536,
      gewascodeOmschrijving: "Grasland, tijdelijk",
      gewasCodeRvo: "266",
      gewasPerceelId: "RVO27378529CFD0000000084092",
      grondsoort: "Klei",
      grondsoortcategorieId: 2,
      grondwatertrap: "II",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1347118,
      oppervlakte: 2.65,
      pal: 3,
      perceelId: 10934,
      perceelNaam: "lange jan verhoef",
      ppae: 3,
      pw: 3,
      fosfaatklasseBepalingMethode: 1,
      fosfaatklasseBepalingMethodeKiesbaar: true,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1534,
      gewascodeOmschrijving: "Grasland, blijvend",
      gewasCodeRvo: "265",
      gewasPerceelId: "RVO27378529CFD0000000666795",
      grondsoort: "Veen",
      grondsoortcategorieId: 1,
      grondwatertrap: "II",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1503619,
      oppervlakte: 2.61,
      perceelId: 10935,
      perceelNaam: "maisland",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1534,
      gewascodeOmschrijving: "Grasland, blijvend",
      gewasCodeRvo: "265",
      gewasPerceelId: "RVO27378529CFD0000000399672",
      grondsoort: "Klei",
      grondsoortcategorieId: 2,
      grondwatertrap: "III",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1340759,
      oppervlakte: 2.23,
      perceelId: 10936,
      perceelNaam: "modderkamp",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1534,
      gewascodeOmschrijving: "Grasland, blijvend",
      gewasCodeRvo: "265",
      gewasPerceelId: "RVO27378529CFD0000000219487",
      grondsoort: "Veen",
      grondsoortcategorieId: 1,
      grondwatertrap: "II",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1616818,
      oppervlakte: 1.45,
      perceelId: 10920,
      perceelNaam: "over nwe brug rechts",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1536,
      gewascodeOmschrijving: "Grasland, tijdelijk",
      gewasCodeRvo: "266",
      gewasPerceelId: "RVO27378529CFD0000000923825",
      grondsoort: "Klei",
      grondsoortcategorieId: 2,
      grondwatertrap: "III",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1166619,
      oppervlakte: 1.23,
      perceelId: 10929,
      perceelNaam: "paardenkamp pot",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 1,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1529,
      gewascodeOmschrijving: "Maïs, snij-",
      gewasCodeRvo: "259",
      gewasPerceelId: "RVO27378529CFD0000000063893",
      grondsoort: "Veen",
      grondsoortcategorieId: 1,
      grondwatertrap: "II",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1503620,
      oppervlakte: 2.45,
      perceelId: 10919,
      perceelNaam: "plein",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1534,
      gewascodeOmschrijving: "Grasland, blijvend",
      gewasCodeRvo: "265",
      gewasPerceelId: "RVO27378529CFD0000000699041",
      grondsoort: "Veen",
      grondsoortcategorieId: 1,
      grondwatertrap: "II",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1503620,
      oppervlakte: 1.93,
      perceelId: 10907,
      perceelNaam: "plein mais2010",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1536,
      gewascodeOmschrijving: "Grasland, tijdelijk",
      gewasCodeRvo: "266",
      gewasPerceelId: "RVO27378529CFD0000000719240",
      grondsoort: "Klei",
      grondsoortcategorieId: 2,
      grondwatertrap: "II",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1166619,
      oppervlakte: 1.86,
      perceelId: 10899,
      perceelNaam: "pot piet westerhoud",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1536,
      gewascodeOmschrijving: "Grasland, tijdelijk",
      gewasCodeRvo: "266",
      gewasPerceelId: "RVO27378529CFD0000000462298",
      grondsoort: "Klei",
      grondsoortcategorieId: 2,
      grondwatertrap: "III",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1501798,
      oppervlakte: 2.45,
      perceelId: 10900,
      perceelNaam: "start voor",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1534,
      gewascodeOmschrijving: "Grasland, blijvend",
      gewasCodeRvo: "265",
      gewasPerceelId: "RVO27378529CFD0000000303561",
      grondsoort: "Klei",
      grondsoortcategorieId: 2,
      grondwatertrap: "III",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 3832870,
      oppervlakte: 0.66,
      perceelId: 10901,
      perceelNaam: "stierenschuur",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1536,
      gewascodeOmschrijving: "Grasland, tijdelijk",
      gewasCodeRvo: "266",
      gewasPerceelId: "RVO27378529CFD0000000010720",
      grondsoort: "Klei",
      grondsoortcategorieId: 2,
      grondwatertrap: "III",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1501797,
      oppervlakte: 2.9,
      perceelId: 10902,
      perceelNaam: "tien kool voor",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1534,
      gewascodeOmschrijving: "Grasland, blijvend",
      gewasCodeRvo: "265",
      gewasPerceelId: "RVO27378529CFD0000000490014",
      grondsoort: "Klei",
      grondsoortcategorieId: 2,
      grondwatertrap: "III",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1501805,
      oppervlakte: 2.52,
      perceelId: 10903,
      perceelNaam: "van iperen",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 2,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1517,
      gewascodeOmschrijving: "Gerst, winter-",
      gewasCodeRvo: "235",
      gewasPerceelId: "RVO27378529CFD0000000767257",
      grondsoort: "Klei",
      grondsoortcategorieId: 2,
      grondwatertrap: "VI",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1508644,
      oppervlakte: 4.89,
      perceelId: 10904,
      perceelNaam: "van wiggen 3-hoek",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 2,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1517,
      gewascodeOmschrijving: "Gerst, winter-",
      gewasCodeRvo: "235",
      gewasPerceelId: "RVO27378529CFD0000000360326",
      grondsoort: "Klei",
      grondsoortcategorieId: 2,
      grondwatertrap: "IIIb",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1526998,
      oppervlakte: 1.17,
      perceelId: 10905,
      perceelNaam: "van wiggen groot",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 2,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1518,
      gewascodeOmschrijving: "Gerst, zomer-",
      gewasCodeRvo: "236",
      gewasPerceelId: "RVO27378529CFD0000002017259",
      grondsoort: "Klei",
      grondsoortcategorieId: 2,
      grondwatertrap: "IIIb",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1526998,
      oppervlakte: 2.5,
      perceelId: 10906,
      perceelNaam: "van wiggen groot 2 2020",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1534,
      gewascodeOmschrijving: "Grasland, blijvend",
      gewasCodeRvo: "265",
      gewasPerceelId: "RVO27378529CFD0000000252357",
      grondsoort: "Klei",
      grondsoortcategorieId: 2,
      grondwatertrap: "II",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1325307,
      oppervlakte: 0.6,
      perceelId: 10908,
      perceelNaam: "van zuilen eigendom",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1534,
      gewascodeOmschrijving: "Grasland, blijvend",
      gewasCodeRvo: "265",
      gewasPerceelId: "RVO27378529CFD0000000463258",
      grondsoort: "Klei",
      grondsoortcategorieId: 2,
      grondwatertrap: "III",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1325307,
      oppervlakte: 2.06,
      perceelId: 10917,
      perceelNaam: "van zuilen manhuis",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1534,
      gewascodeOmschrijving: "Grasland, blijvend",
      gewasCodeRvo: "265",
      gewasPerceelId: "RVO27378529CFD0000000203253",
      grondsoort: "Klei",
      grondsoortcategorieId: 2,
      grondwatertrap: "III",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 3838636,
      oppervlakte: 0.54,
      perceelId: 10909,
      perceelNaam: "voor erf",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1534,
      gewascodeOmschrijving: "Grasland, blijvend",
      gewasCodeRvo: "265",
      gewasPerceelId: "RVO27378529CFD0000000725863",
      grondsoort: "Veen",
      grondsoortcategorieId: 1,
      grondwatertrap: "II",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1259189,
      oppervlakte: 0.08,
      perceelId: 10910,
      perceelNaam: "wetering nieuwe brug",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1534,
      gewascodeOmschrijving: "Grasland, blijvend",
      gewasCodeRvo: "265",
      gewasPerceelId: "RVO27378529CFD0000000735096",
      grondsoort: "Veen",
      grondsoortcategorieId: 1,
      grondwatertrap: "II",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1259242,
      oppervlakte: 0.09,
      perceelId: 10911,
      perceelNaam: "wetering rechts brug",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1534,
      gewascodeOmschrijving: "Grasland, blijvend",
      gewasCodeRvo: "265",
      gewasPerceelId: "RVO27378529CFD0000000144062",
      grondsoort: "Veen",
      grondsoortcategorieId: 1,
      grondwatertrap: "II",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1259243,
      oppervlakte: 0.03,
      perceelId: 10912,
      perceelNaam: "wetering rolia",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 1,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1529,
      gewascodeOmschrijving: "Maïs, snij-",
      gewasCodeRvo: "259",
      gewasPerceelId: "RVO27378529CFD0000000397493",
      grondsoort: "Veen",
      grondsoortcategorieId: 1,
      grondwatertrap: "II",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1501794,
      oppervlakte: 1.63,
      perceelId: 10913,
      perceelNaam: "weteringkamp kruyff",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1536,
      gewascodeOmschrijving: "Grasland, tijdelijk",
      gewasCodeRvo: "266",
      gewasPerceelId: "RVO27378529CFD0000000318789",
      grondsoort: "Veen",
      grondsoortcategorieId: 1,
      grondwatertrap: "II",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1325306,
      oppervlakte: 1.77,
      perceelId: 10914,
      perceelNaam: "weteringkamp manh.",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1534,
      gewascodeOmschrijving: "Grasland, blijvend",
      gewasCodeRvo: "265",
      gewasPerceelId: "RVO27378529CFD0000000719820",
      grondsoort: "Veen",
      grondsoortcategorieId: 1,
      grondwatertrap: "II",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1616461,
      oppervlakte: 1.61,
      perceelId: 10915,
      perceelNaam: "weteringkamp nw brug",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1534,
      gewascodeOmschrijving: "Grasland, blijvend",
      gewasCodeRvo: "265",
      gewasPerceelId: "RVO27378529CFD0000000158169",
      grondsoort: "Veen",
      grondsoortcategorieId: 1,
      grondwatertrap: "II",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1501795,
      oppervlakte: 1.47,
      pal: 1,
      perceelId: 10916,
      perceelNaam: "weteringkamp oma",
      ppae: 1,
      pw: 1,
      fosfaatklasseBepalingMethode: 1,
      fosfaatklasseBepalingMethodeKiesbaar: true,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1536,
      gewascodeOmschrijving: "Grasland, tijdelijk",
      gewasCodeRvo: "266",
      gewasPerceelId: "RVO27378529CFD0000000014345",
      grondsoort: "Veen",
      grondsoortcategorieId: 1,
      grondwatertrap: "II",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1501794,
      oppervlakte: 0.58,
      perceelId: 10854,
      perceelNaam: "weteringkamp piet v.",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1536,
      gewascodeOmschrijving: "Grasland, tijdelijk",
      gewasCodeRvo: "266",
      gewasPerceelId: "RVO27378529CFD0000000213376",
      grondsoort: "Veen",
      grondsoortcategorieId: 1,
      grondwatertrap: "II",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1325306,
      oppervlakte: 1.44,
      perceelId: 10896,
      perceelNaam: "weteringkamp rolia",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 1,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1529,
      gewascodeOmschrijving: "Maïs, snij-",
      gewasCodeRvo: "259",
      gewasPerceelId: "RVO27378529CFD0000000020924",
      grondsoort: "Veen",
      grondsoortcategorieId: 1,
      grondwatertrap: "II",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1325306,
      oppervlakte: 1.32,
      perceelId: 10853,
      perceelNaam: "weteringkamp start",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1534,
      gewascodeOmschrijving: "Grasland, blijvend",
      gewasCodeRvo: "265",
      gewasPerceelId: "RVO27378529CFD0000000237690",
      grondsoort: "Veen",
      grondsoortcategorieId: 1,
      grondwatertrap: "II",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1501807,
      oppervlakte: 1.51,
      perceelId: 10851,
      perceelNaam: "weteringkamp v zuilen",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 4,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: true,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1534,
      gewascodeOmschrijving: "Grasland, blijvend",
      gewasCodeRvo: "265",
      gewasPerceelId: "RVO27378529CFD0000001734961",
      grondsoort: "Veen",
      grondsoortcategorieId: 1,
      grondwatertrap: "II",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1501807,
      oppervlakte: 0.68,
      perceelId: 10852,
      perceelNaam: "weteringkamp_piet_verhoef_strook_west",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
    },
    {
      bouwlandcategorieId: 2,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: false,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1829,
      gewascodeOmschrijving: "Knotboom, bomen in rij",
      gewasCodeRvo: "2643",
      gewasPerceelId: "RVO27378529CFD0000000136996",
      grondsoortcategorieId: 0,
      grondwatertrap: "III",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      oppervlakte: 0.01,
      perceelId: 10926,
      perceelNaam: "knotbomen erf west",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: false,
    },
    {
      bouwlandcategorieId: 2,
      creatieDatum: "2022-01-20T13:32:38.045",
      doorrekenen: false,
      fixerend: false,
      geoogstGewas: [],
      gewascodeId: 1829,
      gewascodeOmschrijving: "Knotboom, bomen in rij",
      gewasCodeRvo: "2643",
      gewasPerceelId: "RVO27378529CFD0000000438984",
      grondsoort: "Klei",
      grondsoortcategorieId: 2,
      grondwatertrap: "II",
      handmatig: false,
      isGemonsterd: false,
      klaverPercentage: 0,
      rvoObjectId: 1501804,
      oppervlakte: 0.01,
      perceelId: 10927,
      perceelNaam: "knotbomen langs huibert",
      fosfaatklasseBepalingMethode: 2,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: false,
    },
  ],
  gewascodes: [
    {
      gewascodeId: 1507,
      code: "2025",
      omschrijving: "Aardappelen, bestrijdingsmaatregel AM",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1503,
      code: "2014",
      omschrijving: "Aardappelen, consumptie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1843,
      code: "2951",
      omschrijving: "Aardappelen, consumptie, op klei/lössgrond",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1855,
      code: "3792",
      omschrijving: "Aardappelen, consumptie, op zand/veengrond",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1504,
      code: "2015",
      omschrijving: "Aardappelen, poot NAK",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1505,
      code: "2016",
      omschrijving: "Aardappelen, poot TBM",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1852,
      code: "3730",
      omschrijving: "Aardappelen, poot, op klei/lössgrond (NAK)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1853,
      code: "3731",
      omschrijving: "Aardappelen, poot, op zand/veengrond (NAK)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1506,
      code: "2017",
      omschrijving: "Aardappelen, zetmeel ",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1854,
      code: "3732",
      omschrijving: "Aardappelen, zetmeel (incl. TBM pootgoed)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1543,
      code: "2706",
      omschrijving: "Aardbeien op stellingen, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: true,
    },
    {
      gewascodeId: 1541,
      code: "2704",
      omschrijving: "Aardbeien op stellingen, vermeerdering",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: true,
    },
    {
      gewascodeId: 1542,
      code: "2705",
      omschrijving: "Aardbeien op stellingen, wachtbed",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: true,
    },
    {
      gewascodeId: 1544,
      code: "2707",
      omschrijving: "Aardbeien op stellingen, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: true,
    },
    {
      gewascodeId: 1539,
      code: "2702",
      omschrijving: "Aardbeien open grond, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1537,
      code: "2700",
      omschrijving: "Aardbeien open grond, vermeerdering",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1538,
      code: "2701",
      omschrijving: "Aardbeien open grond, wachtbed",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1540,
      code: "2703",
      omschrijving: "Aardbeien open grond, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1501,
      code: "1949",
      omschrijving: "Aardperen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1795,
      code: "1045",
      omschrijving: "Adonis",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1808,
      code: "1926",
      omschrijving: "Agrarisch natuurmengsel",
      bcid: 3,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1452,
      code: "1007",
      omschrijving: "Amaryllis, bloembollen en -knollen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1733,
      code: "995",
      omschrijving: "Amaryllis, droogbloemen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1732,
      code: "994",
      omschrijving: "Amaryllis, overige bloemkwekerijgewassen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1545,
      code: "2708",
      omschrijving: "Andijvie, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1546,
      code: "2709",
      omschrijving: "Andijvie, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1792,
      code: "1042",
      omschrijving: "Angelica, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1793,
      code: "1043",
      omschrijving: "Angelica, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1481,
      code: "1095",
      omschrijving: "Appelen. Aangeplant lopende seizoen.",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1482,
      code: "1096",
      omschrijving: "Appelen. Aangeplant voorafgaande aan lopende seizoen.",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1548,
      code: "2711",
      omschrijving: "Asperges, oppervlakte die nog geen productie oplevert",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1547,
      code: "2710",
      omschrijving: "Asperges, oppervlakte die productie oplevert",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1549,
      code: "2712",
      omschrijving: "Asperges, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1568,
      code: "2731",
      omschrijving: "Augurk, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1569,
      code: "2732",
      omschrijving: "Augurk, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1648,
      code: "3501",
      omschrijving: "Beemdlangbloem",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1489,
      code: "1869",
      omschrijving: "Bessen, blauwe",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1511,
      code: "2325",
      omschrijving: "Bessen, rode",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1492,
      code: "1873",
      omschrijving:
        "Bessen, zwarte (opbrengst verwerkt voor verwerkende industrie)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1526,
      code: "256",
      omschrijving: "Bieten, suiker-",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1527,
      code: "257",
      omschrijving: "Bieten, voeder-",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1832,
      code: "2651",
      omschrijving: "Bieten, voeder- (inclusief aardperen)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1649,
      code: "3502",
      omschrijving: "Bladkool",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1650,
      code: "3503",
      omschrijving: "Bladraap",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1651,
      code: "3504",
      omschrijving: "Bladrammenas",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1765,
      code: "1015",
      omschrijving: "Blauw druifje, bloembollen en -knollen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1764,
      code: "1014",
      omschrijving: "Blauw druifje, droogbloemen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1763,
      code: "1013",
      omschrijving: "Blauw druifje, overige bloemkwekerijgewassen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1525,
      code: "247",
      omschrijving: "Blauwmaanzaad",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1807,
      code: "176",
      omschrijving: "Bloembollen en -knollen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1550,
      code: "2713",
      omschrijving: "Bloemkool, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1834,
      code: "2795",
      omschrijving: "Bloemkool, winter, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1835,
      code: "2796",
      omschrijving: "Bloemkool, winter, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1551,
      code: "2714",
      omschrijving: "Bloemkool, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1836,
      code: "2797",
      omschrijving: "Bloemkool, zomer, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1837,
      code: "2798",
      omschrijving: "Bloemkool, zomer, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1806,
      code: "175",
      omschrijving: "Bloemkwekerijgewassen (inclusief bloemzaden)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1488,
      code: "174",
      omschrijving: "Bloemzaden open grond",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1552,
      code: "2715",
      omschrijving: "Boerenkool, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1553,
      code: "2716",
      omschrijving: "Boerenkool, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1522,
      code: "242",
      omschrijving: "Bonen, bruine-",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1707,
      code: "853",
      omschrijving: "Bonen, tuin- (droog te oogsten) (geen consumptie)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1708,
      code: "854",
      omschrijving: "Bonen, tuin- (groen te oogsten)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1822,
      code: "243",
      omschrijving:
        "Bonen, veld- (onder andere duive-, paarde-, wierbonen) (droog te oogsten)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1633,
      code: "311",
      omschrijving: "Bonen, veld- (onder andere duiven-, paarden-, wierbonen) ",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1861,
      code: "3806",
      omschrijving: "Boomkwekerijgewassen en vaste planten, open grond",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1842,
      code: "294",
      omschrijving:
        "Boomkwekerijgewassen en vaste planten, pot- en containerveld",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1554,
      code: "2717",
      omschrijving: "Bospeen, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1555,
      code: "2718",
      omschrijving: "Bospeen, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1815,
      code: "2026",
      omschrijving: "Braak, met bos (SBL-regeling na 28 juni 1995)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1817,
      code: "2029",
      omschrijving: "Braak, natuur",
      bcid: 3,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1513,
      code: "2327",
      omschrijving: "Bramen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1687,
      code: "654",
      omschrijving: "Brandnetel",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1556,
      code: "2719",
      omschrijving: "Broccoli, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1557,
      code: "2720",
      omschrijving: "Brocolli, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1454,
      code: "1068",
      omschrijving: "Buxus, open grond,",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1558,
      code: "2721",
      omschrijving: "Chinese kool, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1559,
      code: "2722",
      omschrijving: "Chinese kool, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1791,
      code: "1041",
      omschrijving: "Chrysant, bloembollen en -knollen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1790,
      code: "1040",
      omschrijving: "Chrysant, droogbloemen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1789,
      code: "1039",
      omschrijving: "Chrysant, overige bloemkwekerijgewassen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1805,
      code: "1055",
      omschrijving: "Chrysant, vermeerdering",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1682,
      code: "511",
      omschrijving: "Cichorei",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1560,
      code: "2723",
      omschrijving: "Courgette, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1561,
      code: "2724",
      omschrijving: "Courgette, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1797,
      code: "1047",
      omschrijving: "Cranberry",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1734,
      code: "997",
      omschrijving: "Dahlia, bloembollen en - knollen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1713,
      code: "965",
      omschrijving: "Dahlia, droogbloemen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1712,
      code: "964",
      omschrijving: "Dahlia, overige bloemkwekerijgewassen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1652,
      code: "3505",
      omschrijving: "Deder",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1867,
      code: "657",
      omschrijving: "Drachtplanten",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1798,
      code: "1048",
      omschrijving: "Echinacea (zonnehoed), productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1799,
      code: "1049",
      omschrijving: "Echinacea (zonnehoed), zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1653,
      code: "3506",
      omschrijving: "Engels raaigras",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1455,
      code: "1069",
      omschrijving:
        "Ericaceae (Zoals erica, calluna, rododendron, azalea), open grond,",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1469,
      code: "1083",
      omschrijving:
        "Ericaceae (Zoals erica, calluna, rododendron, azalea), pot- en containerveld,",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1632,
      code: "308",
      omschrijving: "Erwten (droog te oogsten)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1831,
      code: "2650",
      omschrijving: "Erwten inclusief schokkers (droog te oogsten)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1523,
      code: "244",
      omschrijving: "Erwten, groene/gele (groen te oogsten)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1702,
      code: "801",
      omschrijving: "Esparcette",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1654,
      code: "3507",
      omschrijving: "Ethiopische mosterd",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1655,
      code: "3508",
      omschrijving: "Facelia",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1850,
      code: "3721",
      omschrijving: "Faunaranden, bouwland",
      bcid: 3,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1849,
      code: "3720",
      omschrijving: "Faunaranden, grasland",
      bcid: 3,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1656,
      code: "3509",
      omschrijving: "Festulolium",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1512,
      code: "2326",
      omschrijving: "Frambozen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1657,
      code: "3510",
      omschrijving: "Franse boekweit",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1818,
      code: "212",
      omschrijving: "Fruit",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1681,
      code: "428",
      omschrijving: "Gele mosterd",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1517,
      code: "235",
      omschrijving: "Gerst, winter-",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1518,
      code: "236",
      omschrijving: "Gerst, zomer-",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1735,
      code: "998",
      omschrijving: "Gladiool, bloembollen en - knollen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1715,
      code: "968",
      omschrijving: "Gladiool, droogbloemen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1714,
      code: "967",
      omschrijving: "Gladiool, overige bloemkwekerijgewassen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1782,
      code: "1032",
      omschrijving: "Goudsbloem",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1534,
      code: "265",
      omschrijving: "Grasland, blijvend",
      bcid: 4,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1847,
      code: "3718",
      omschrijving: "Grasland, natuurlijk",
      bcid: 3,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1844,
      code: "336",
      omschrijving:
        "Grasland, natuurlijk. Areaal dat overwegend voor landbouwactiviteiten-GLB wordt gebruikt.",
      bcid: 3,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1637,
      code: "331",
      omschrijving: "Grasland, natuurlijk. Hoofdfunctie landbouw.",
      bcid: 4,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1638,
      code: "332",
      omschrijving: "Grasland, natuurlijk. Hoofdfunctie natuur.",
      bcid: 3,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1536,
      code: "266",
      omschrijving: "Grasland, tijdelijk",
      bcid: 4,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1678,
      code: "383",
      omschrijving: "Graszaad",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1833,
      code: "2653",
      omschrijving: "Graszaad (inclusief klaverzaad)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1495,
      code: "1921",
      omschrijving: "Graszoden",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1821,
      code: "2299",
      omschrijving: "Groenbemesters, niet-vlinderbloemige-",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1820,
      code: "2298",
      omschrijving: "Groenbemesters, vlinderbloemige-",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1868,
      code: "672",
      omschrijving: "Groenten open grond (inclusief groentezaden)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1520,
      code: "238",
      omschrijving: "Haver",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1848,
      code: "3719",
      omschrijving: "Heide",
      bcid: 3,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1711,
      code: "944",
      omschrijving: "Hennep, vezel-",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1745,
      code: "2628",
      omschrijving: "Hoogstamboomgaard",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1675,
      code: "375",
      omschrijving: "Hop",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1736,
      code: "1.51",
      omschrijving: "Hyacint, bloembollen en - knollen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1717,
      code: "971",
      omschrijving: "Hyacint, droogbloemen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1716,
      code: "970",
      omschrijving: "Hyacint, overige bloemkwekerijgewassen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1783,
      code: "1033",
      omschrijving: "Igniscum Candy",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1445,
      code: "1000",
      omschrijving: "Iris, bloembollen en -knollen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1801,
      code: "1051",
      omschrijving: "Iris, Bolvormend",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1719,
      code: "974",
      omschrijving: "Iris, droogbloemen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1718,
      code: "973",
      omschrijving: "Iris, overige bloemkwekerijgewassen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1802,
      code: "1052",
      omschrijving: "Iris, Rhizoomvormend",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1659,
      code: "3512",
      omschrijving: "Italiaans raaigras",
      bcid: 4,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1695,
      code: "670",
      omschrijving: "Japanse haver",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1784,
      code: "1034",
      omschrijving: "Kanariezaad",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1521,
      code: "241",
      omschrijving: "Kapucijners (en grauwe erwten)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1524,
      code: "246",
      omschrijving: "Karwijzaad (oogst dit jaar)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1514,
      code: "2328",
      omschrijving: "Kersen, zoet",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1491,
      code: "1872",
      omschrijving:
        "Kersen, zuur (opbrengst bestemd voor verwerkende industrie)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1699,
      code: "796",
      omschrijving: "Kerstbomen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1647,
      code: "3500",
      omschrijving: "Klaver, Alexandrijnse",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1658,
      code: "3511",
      omschrijving: "Klaver, incarnaat",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1662,
      code: "3515",
      omschrijving: "Klaver, Perzische",
      bcid: 4,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1700,
      code: "799",
      omschrijving: "Klaver, rode",
      bcid: 4,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1671,
      code: "3524",
      omschrijving: "Klaver, witte",
      bcid: 4,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1705,
      code: "804",
      omschrijving: "Klaverzaad",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1771,
      code: "1021",
      omschrijving: "Knoflook",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1562,
      code: "2725",
      omschrijving: "Knolselderij, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1563,
      code: "2726",
      omschrijving: "Knolselderij, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1564,
      code: "2727",
      omschrijving: "Knolvenkel/venkel, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1565,
      code: "2728",
      omschrijving: "Knolvenkel/venkel, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1566,
      code: "2729",
      omschrijving: "Komkommer, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1567,
      code: "2730",
      omschrijving: "Komkommer, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1574,
      code: "2737",
      omschrijving: "Koolraap, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1575,
      code: "2738",
      omschrijving: "Koolraap, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1576,
      code: "2739",
      omschrijving: "Koolrabi, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1577,
      code: "2740",
      omschrijving: "Koolrabi, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1496,
      code: "1922",
      omschrijving: "Koolzaad, winter (incl. boterzaad)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1497,
      code: "1923",
      omschrijving: "Koolzaad, zomer (incl. boterzaad)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1446,
      code: "1001",
      omschrijving: "Krokus, bloembollen en - knollen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1721,
      code: "977",
      omschrijving: "Krokus, droogbloemen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1720,
      code: "976",
      omschrijving: "Krokus, overige bloemkwekerijgewassen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1578,
      code: "2741",
      omschrijving: "Kroten/rode bieten, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1579,
      code: "2742",
      omschrijving: "Kroten/rode bieten, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1580,
      code: "2743",
      omschrijving: "Kruiden, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1581,
      code: "2744",
      omschrijving: "Kruiden, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1768,
      code: "1018",
      omschrijving: "Kuifhyacint, bloembollen en -knollen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1767,
      code: "1017",
      omschrijving: "Kuifhyacint, droogbloemen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1766,
      code: "1016",
      omschrijving: "Kuifhyacint, overige bloemkwekerijgewassen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1456,
      code: "1070",
      omschrijving: "Laanbomen/parkbomen, onderstammen, open grond,",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1457,
      code: "1071",
      omschrijving: "Laanbomen/parkbomen, opzetters, open grond,",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1458,
      code: "1072",
      omschrijving: "Laanbomen/parkbomen, spillen, open grond,",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1778,
      code: "1028",
      omschrijving: "Lavas (Maggiplant), productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1779,
      code: "1029",
      omschrijving: "Lavas (Maggiplant), zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1800,
      code: "1050",
      omschrijving: "Leeuwenbekjes",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1447,
      code: "1002",
      omschrijving: "Lelie, bloembollen en -knollen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1723,
      code: "980",
      omschrijving: "Lelie, droogbloemen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1722,
      code: "979",
      omschrijving: "Lelie, overige bloemkwekerijgewassen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1690,
      code: "663",
      omschrijving: "Lupinen, niet bittere",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1528,
      code: "258",
      omschrijving: "Luzerne",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1636,
      code: "317",
      omschrijving: "Maïs, corncob mix",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1508,
      code: "2032",
      omschrijving: "Maïs, energie-",
      bcid: 1,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1635,
      code: "316",
      omschrijving: "Maïs, korrel-",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1529,
      code: "259",
      omschrijving: "Maïs, snij-",
      bcid: 1,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1706,
      code: "814",
      omschrijving: "Maïs, suiker-",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1814,
      code: "1935",
      omschrijving: "Maiskolvensilage",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1685,
      code: "652",
      omschrijving: "Meekrap",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1570,
      code: "2733",
      omschrijving: "Meloen, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1571,
      code: "2734",
      omschrijving: "Meloen, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1684,
      code: "516",
      omschrijving: "Miscanthus (olifantsgras)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1785,
      code: "1035",
      omschrijving: "Naaldaar (Setaria)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1448,
      code: "1003",
      omschrijving: "Narcis, bloembollen en -knollen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1725,
      code: "983",
      omschrijving: "Narcis, droogbloemen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1724,
      code: "982",
      omschrijving: "Narcis, overige bloemkwekerijgewassen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1641,
      code: "335",
      omschrijving: "Natuurterreinen (incl. heide)",
      bcid: 3,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1661,
      code: "3514",
      omschrijving: "Niger",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1533,
      code: "2645",
      omschrijving: "Notenbomen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1509,
      code: "2033",
      omschrijving: "Onbeteelde grond, tijdelijk",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1493,
      code: "1874",
      omschrijving: "Overig kleinfruit (zoals kruisbessen, kiwi's)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1498,
      code: "1925",
      omschrijving: "Overige akkerbouwgewassen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1809,
      code: "1927",
      omschrijving: "Overige akkerbouwgewassen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1451,
      code: "1006",
      omschrijving: "Overige bloemen, bloembollen en -knollen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1731,
      code: "992",
      omschrijving: "Overige bloemen, droogbloemen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1730,
      code: "991",
      omschrijving: "Overige bloemen, overige bloemkwekerijgewassen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1535,
      code: "2652",
      omschrijving: "Overige granen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1680,
      code: "427",
      omschrijving: "Overige groenbemesters, niet-vlinderbloemige-",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1679,
      code: "426",
      omschrijving: "Overige groenbemesters, vlinderbloemige- ",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1851,
      code: "3722",
      omschrijving: "Overige natuurterreinen",
      bcid: 3,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1628,
      code: "2791",
      omschrijving: "Overige niet genoemde bladgewassen, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1629,
      code: "2792",
      omschrijving:
        "Overige niet genoemde bladgewassen, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1630,
      code: "2793",
      omschrijving: "Overige niet genoemde groenten, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1631,
      code: "2794",
      omschrijving: "Overige niet genoemde groenten, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1486,
      code: "1100",
      omschrijving:
        "Overige pit- en steenvruchten (zoals perziken, tafeldruiven)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1582,
      code: "2745",
      omschrijving: "Paksoi, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1583,
      code: "2746",
      omschrijving: "Paksoi, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1794,
      code: "1044",
      omschrijving: "Papaver",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1773,
      code: "1023",
      omschrijving: "Pastinaak, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1774,
      code: "1024",
      omschrijving: "Pastinaak, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1483,
      code: "1097",
      omschrijving: "Peren. Aangeplant lopende seizoen.",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1484,
      code: "1098",
      omschrijving: "Peren. Aangeplant voorafgaande aan lopende seizoen.",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1787,
      code: "1037",
      omschrijving: "Peterselie, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1788,
      code: "1038",
      omschrijving: "Peterselie, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1584,
      code: "2747",
      omschrijving: "Peulen, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1585,
      code: "2748",
      omschrijving: "Peulen, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1777,
      code: "1027",
      omschrijving: "Pioenroos, bloembollen en -knollen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1776,
      code: "1026",
      omschrijving: "Pioenroos, droogbloemen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1775,
      code: "1025",
      omschrijving: "Pioenroos, overige bloemkwekerijgewassen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1804,
      code: "1054",
      omschrijving: "Pioenroos, vermeerdering",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1572,
      code: "2735",
      omschrijving: "Pompoen, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1573,
      code: "2736",
      omschrijving: "Pompoen, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1586,
      code: "2749",
      omschrijving: "Prei, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1838,
      code: "2799",
      omschrijving: "Prei, winter, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1839,
      code: "2800",
      omschrijving: "Prei, winter, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1587,
      code: "2750",
      omschrijving: "Prei, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1840,
      code: "2801",
      omschrijving: "Prei, zomer, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1841,
      code: "2802",
      omschrijving: "Prei, zomer, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1588,
      code: "2751",
      omschrijving: "Pronkbonen, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1589,
      code: "2752",
      omschrijving: "Pronkbonen, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1490,
      code: "1870",
      omschrijving: "Pruimen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1772,
      code: "1022",
      omschrijving: "Quinoa",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1590,
      code: "2753",
      omschrijving: "Raapstelen, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1591,
      code: "2754",
      omschrijving: "Raapstelen, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1691,
      code: "664",
      omschrijving: "Raapzaad",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1592,
      code: "2755",
      omschrijving: "Rabarber, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1593,
      code: "2756",
      omschrijving: "Rabarber, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1594,
      code: "2757",
      omschrijving: "Radijs, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1595,
      code: "2758",
      omschrijving: "Radijs, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1696,
      code: "671",
      omschrijving: "Raketblad (aaltjesvanggewas)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1639,
      code: "333",
      omschrijving:
        "Rand, grenzend aan blijvend grasland of een blijvende teelt, hoofdzakelijk bestaand uit blijvend gras",
      bcid: 4,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1643,
      code: "344",
      omschrijving:
        "Rand, grenzend aan blijvend grasland of een blijvende teelt, hoofdzakelijk bestaand uit een ander gewas dan gras",
      bcid: 4,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1672,
      code: "370",
      omschrijving:
        "Rand, grenzend aan blijvend grasland of een blijvende teelt, hoofdzakelijk bestaand uit tijdelijk gras",
      bcid: 4,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1640,
      code: "334",
      omschrijving:
        "Rand, grenzend aan bouwland, hoofdzakelijk bestaand uit blijvend gras",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1644,
      code: "345",
      omschrijving:
        "Rand, grenzend aan bouwland, hoofdzakelijk bestaand uit een ander gewas dan gras",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1858,
      code: "3803",
      omschrijving:
        "Rand, grenzend aan bouwland, hoofdzakelijk bestaand uit een ander gewas dan gras. (EA: beheer)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1859,
      code: "3804",
      omschrijving:
        "Rand, grenzend aan bouwland, hoofdzakelijk bestaand uit een ander gewas dan gras. (EA: onbeheerd)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1673,
      code: "372",
      omschrijving:
        "Rand, grenzend aan bouwland, hoofdzakelijk bestaand uit tijdelijk gras",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1846,
      code: "338",
      omschrijving:
        "Rand, liggend op bouwland en direct grenzend aan bos. Geen landbouwproductie.",
      bcid: 3,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1663,
      code: "3516",
      omschrijving: "Rietzwenkgras",
      bcid: 4,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1862,
      code: "3807",
      omschrijving: "Rietzwenkgras, anders dan voor industriegras",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1860,
      code: "3805",
      omschrijving: "Rietzwenkgras, industriegras",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1596,
      code: "2759",
      omschrijving: "Rodekool, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1597,
      code: "2760",
      omschrijving: "Rodekool, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1519,
      code: "237",
      omschrijving: "Rogge (geen snijrogge)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1701,
      code: "800",
      omschrijving: "Rolklaver",
      bcid: 4,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1863,
      code: "3808",
      omschrijving: "Roodzwenkgras",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1459,
      code: "1073",
      omschrijving:
        "Rozenstruiken (incl, zaailingen en onderstammen), open grond,",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1864,
      code: "636",
      omschrijving: "Saffloer",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1664,
      code: "3517",
      omschrijving: "Sarepta mosterd/Caliente",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1598,
      code: "2761",
      omschrijving: "Savooiekool, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1599,
      code: "2762",
      omschrijving: "Savooiekool, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1601,
      code: "2764",
      omschrijving: "Schorseneren, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1600,
      code: "2763",
      omschrijving: "Schorseneren; productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1602,
      code: "2765",
      omschrijving: "Selderij, bleek- en groen-, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1603,
      code: "2766",
      omschrijving: "Selderij, bleek- en groen-, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1665,
      code: "3518",
      omschrijving: "Seradelle",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1460,
      code: "1074",
      omschrijving: "Sierconiferen, open grond,",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1461,
      code: "1075",
      omschrijving: "Sierheesters en klimplanten, open grond,",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1762,
      code: "1012",
      omschrijving: "Sierui, bloembollen en -knollen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1761,
      code: "1011",
      omschrijving: "Sierui, droogbloemen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1760,
      code: "1010",
      omschrijving: "Sierui, overige bloemkwekerijgewassen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1813,
      code: "1934",
      omschrijving: "Sjalotten",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1604,
      code: "2767",
      omschrijving: "Sla, ijsberg-, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1605,
      code: "2768",
      omschrijving: "Sla, ijsberg-, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1608,
      code: "2771",
      omschrijving: "Sla; overig, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1609,
      code: "2772",
      omschrijving: "Sla; overig, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1606,
      code: "2769",
      omschrijving: "Sla; radicchio rosso, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1607,
      code: "2770",
      omschrijving: "Sla; radicchio rosso, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1494,
      code: "1876",
      omschrijving: "Snijgroen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1666,
      code: "3519",
      omschrijving: "Soedangras/Sorghum",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1692,
      code: "665",
      omschrijving: "Sojabonen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1677,
      code: "382",
      omschrijving: "Spelt",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1610,
      code: "2773",
      omschrijving: "Spinazie, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1611,
      code: "2774",
      omschrijving: "Spinazie, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1612,
      code: "2775",
      omschrijving: "Spitskool, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1613,
      code: "2776",
      omschrijving: "Spitskool, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1614,
      code: "2777",
      omschrijving: "Spruitkool/spruitjes, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1615,
      code: "2778",
      omschrijving: "Spruitkool/spruitjes, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1667,
      code: "3520",
      omschrijving: "Spurrie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1616,
      code: "2779",
      omschrijving: "Stamsperziebonen (=stamslabonen), productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1617,
      code: "2780",
      omschrijving:
        "Stamsperziebonen (=stamslabonen), zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1618,
      code: "2781",
      omschrijving: "Stoksnijbonen en stokslabonen, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1619,
      code: "2782",
      omschrijving: "Stoksnijbonen en stokslabonen, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1668,
      code: "3521",
      omschrijving: "Stoppelknollen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1810,
      code: "1930",
      omschrijving: "Tagetes (zand, löss) (geen groene braak)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1645,
      code: "346",
      omschrijving: "Tagetes erecta (Afrikaantje)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1646,
      code: "347",
      omschrijving: "Tagetes patula (Afrikaantje)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1515,
      code: "233",
      omschrijving: "Tarwe, winter-",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1516,
      code: "234",
      omschrijving: "Tarwe, zomer-",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1676,
      code: "381",
      omschrijving: "Teff",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1686,
      code: "653",
      omschrijving: "Teunisbloem",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1669,
      code: "3522",
      omschrijving: "Timothee",
      bcid: 4,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1462,
      code: "1076",
      omschrijving: "Trek- en besheesters, open grond,",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1634,
      code: "314",
      omschrijving: "Triticale",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1449,
      code: "1004",
      omschrijving: "Tulp, bloembollen en -knollen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1727,
      code: "986",
      omschrijving: "Tulp, droogbloemen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1726,
      code: "985",
      omschrijving: "Tulp, overige bloemkwekerijgewassen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1499,
      code: "1931",
      omschrijving: "Uien, poot- en plant- (incl. sjalotten)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1811,
      code: "1932",
      omschrijving: "Uien, poot en plant, 1e jaars",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1812,
      code: "1933",
      omschrijving: "Uien, poot en plant, 2e jaars",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1530,
      code: "262",
      omschrijving: "Uien, zaai-",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1531,
      code: "263",
      omschrijving: "Uien, zilver-",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1769,
      code: "1019",
      omschrijving: "Valeriaan, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1770,
      code: "1020",
      omschrijving: "Valeriaan, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1466,
      code: "1080",
      omschrijving: "Vaste planten, open grond,",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1670,
      code: "3523",
      omschrijving: "Veldbeemdgras",
      bcid: 4,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1796,
      code: "1046",
      omschrijving: "Vergeet mij nietje",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1693,
      code: "666",
      omschrijving: "Vlas, olie-. Lijnzaad niet van vezelvlas",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1674,
      code: "3736",
      omschrijving: "Vlas, vezel-",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1865,
      code: "637",
      omschrijving: "Vrouwenmantel",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1463,
      code: "1077",
      omschrijving: "Vruchtbomen, moerbomen, open grond,",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1464,
      code: "1078",
      omschrijving: "Vruchtbomen, onderstammen, open grond,",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1465,
      code: "1079",
      omschrijving: "Vruchtbomen, overig, open grond,",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1620,
      code: "2783",
      omschrijving: "Waspeen, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1621,
      code: "2784",
      omschrijving: "Waspeen, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1660,
      code: "3513",
      omschrijving: "Westerwolds raaigras",
      bcid: 4,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1485,
      code: "1099",
      omschrijving: "Wijndruiven",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1703,
      code: "802",
      omschrijving: "Wikke, bonte",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1704,
      code: "803",
      omschrijving: "Wikke, voeder-",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1780,
      code: "1030",
      omschrijving: "Wilde marjolein (Oregano), productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1781,
      code: "1031",
      omschrijving: "Wilde marjolein (Oregano), zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1622,
      code: "2785",
      omschrijving: "Winterpeen, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1623,
      code: "2786",
      omschrijving: "Winterpeen, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1624,
      code: "2787",
      omschrijving: "Witlofwortel, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1625,
      code: "2788",
      omschrijving: "Witlofwortel, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1626,
      code: "2789",
      omschrijving: "Witte kool, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1627,
      code: "2790",
      omschrijving: "Witte kool, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1786,
      code: "1036",
      omschrijving: "Wortelpeterselie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1819,
      code: "2297",
      omschrijving: "Woudbomen met korte omlooptijd",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1450,
      code: "1005",
      omschrijving: "Zantedeschia, bloembollen en -knollen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1729,
      code: "989",
      omschrijving: "Zantedeschia, droogbloemen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1728,
      code: "988",
      omschrijving: "Zantedeschia, overige bloemkwekerijgewassen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1683,
      code: "515",
      omschrijving: "Zonnebloemen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1866,
      code: "656",
      omschrijving: "Zonnekroon",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1694,
      code: "669",
      omschrijving: "Zwaardherik (aaltjesvanggewas)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: true,
    },
    {
      gewascodeId: 1688,
      code: "655",
      omschrijving: "Zwarte mosterd",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
  ],
  gewascodesPercelenDetail: [
    {
      gewascodeId: 1507,
      code: "2025",
      omschrijving: "Aardappelen, bestrijdingsmaatregel AM",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1503,
      code: "2014",
      omschrijving: "Aardappelen, consumptie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1843,
      code: "2951",
      omschrijving: "Aardappelen, consumptie, op klei/lössgrond",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1855,
      code: "3792",
      omschrijving: "Aardappelen, consumptie, op zand/veengrond",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1504,
      code: "2015",
      omschrijving: "Aardappelen, poot NAK",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1505,
      code: "2016",
      omschrijving: "Aardappelen, poot TBM",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1852,
      code: "3730",
      omschrijving: "Aardappelen, poot, op klei/lössgrond (NAK)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1853,
      code: "3731",
      omschrijving: "Aardappelen, poot, op zand/veengrond (NAK)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1506,
      code: "2017",
      omschrijving: "Aardappelen, zetmeel ",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1854,
      code: "3732",
      omschrijving: "Aardappelen, zetmeel (incl. TBM pootgoed)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1543,
      code: "2706",
      omschrijving: "Aardbeien op stellingen, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: true,
    },
    {
      gewascodeId: 1541,
      code: "2704",
      omschrijving: "Aardbeien op stellingen, vermeerdering",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: true,
    },
    {
      gewascodeId: 1542,
      code: "2705",
      omschrijving: "Aardbeien op stellingen, wachtbed",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: true,
    },
    {
      gewascodeId: 1544,
      code: "2707",
      omschrijving: "Aardbeien op stellingen, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: true,
    },
    {
      gewascodeId: 1539,
      code: "2702",
      omschrijving: "Aardbeien open grond, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1537,
      code: "2700",
      omschrijving: "Aardbeien open grond, vermeerdering",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1538,
      code: "2701",
      omschrijving: "Aardbeien open grond, wachtbed",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1540,
      code: "2703",
      omschrijving: "Aardbeien open grond, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1501,
      code: "1949",
      omschrijving: "Aardperen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1795,
      code: "1045",
      omschrijving: "Adonis",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1808,
      code: "1926",
      omschrijving: "Agrarisch natuurmengsel",
      bcid: 3,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1452,
      code: "1007",
      omschrijving: "Amaryllis, bloembollen en -knollen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1733,
      code: "995",
      omschrijving: "Amaryllis, droogbloemen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1732,
      code: "994",
      omschrijving: "Amaryllis, overige bloemkwekerijgewassen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1545,
      code: "2708",
      omschrijving: "Andijvie, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1546,
      code: "2709",
      omschrijving: "Andijvie, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1792,
      code: "1042",
      omschrijving: "Angelica, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1793,
      code: "1043",
      omschrijving: "Angelica, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1481,
      code: "1095",
      omschrijving: "Appelen. Aangeplant lopende seizoen.",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1482,
      code: "1096",
      omschrijving: "Appelen. Aangeplant voorafgaande aan lopende seizoen.",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1548,
      code: "2711",
      omschrijving: "Asperges, oppervlakte die nog geen productie oplevert",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1547,
      code: "2710",
      omschrijving: "Asperges, oppervlakte die productie oplevert",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1549,
      code: "2712",
      omschrijving: "Asperges, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1568,
      code: "2731",
      omschrijving: "Augurk, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1569,
      code: "2732",
      omschrijving: "Augurk, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1648,
      code: "3501",
      omschrijving: "Beemdlangbloem",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1489,
      code: "1869",
      omschrijving: "Bessen, blauwe",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1511,
      code: "2325",
      omschrijving: "Bessen, rode",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1492,
      code: "1873",
      omschrijving:
        "Bessen, zwarte (opbrengst verwerkt voor verwerkende industrie)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1526,
      code: "256",
      omschrijving: "Bieten, suiker-",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1527,
      code: "257",
      omschrijving: "Bieten, voeder-",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1832,
      code: "2651",
      omschrijving: "Bieten, voeder- (inclusief aardperen)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1649,
      code: "3502",
      omschrijving: "Bladkool",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1650,
      code: "3503",
      omschrijving: "Bladraap",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1651,
      code: "3504",
      omschrijving: "Bladrammenas",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1765,
      code: "1015",
      omschrijving: "Blauw druifje, bloembollen en -knollen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1764,
      code: "1014",
      omschrijving: "Blauw druifje, droogbloemen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1763,
      code: "1013",
      omschrijving: "Blauw druifje, overige bloemkwekerijgewassen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1525,
      code: "247",
      omschrijving: "Blauwmaanzaad",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1807,
      code: "176",
      omschrijving: "Bloembollen en -knollen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1550,
      code: "2713",
      omschrijving: "Bloemkool, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1834,
      code: "2795",
      omschrijving: "Bloemkool, winter, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1835,
      code: "2796",
      omschrijving: "Bloemkool, winter, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1551,
      code: "2714",
      omschrijving: "Bloemkool, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1836,
      code: "2797",
      omschrijving: "Bloemkool, zomer, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1837,
      code: "2798",
      omschrijving: "Bloemkool, zomer, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1806,
      code: "175",
      omschrijving: "Bloemkwekerijgewassen (inclusief bloemzaden)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1488,
      code: "174",
      omschrijving: "Bloemzaden open grond",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1552,
      code: "2715",
      omschrijving: "Boerenkool, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1553,
      code: "2716",
      omschrijving: "Boerenkool, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1522,
      code: "242",
      omschrijving: "Bonen, bruine-",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1707,
      code: "853",
      omschrijving: "Bonen, tuin- (droog te oogsten) (geen consumptie)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1708,
      code: "854",
      omschrijving: "Bonen, tuin- (groen te oogsten)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1822,
      code: "243",
      omschrijving:
        "Bonen, veld- (onder andere duive-, paarde-, wierbonen) (droog te oogsten)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1633,
      code: "311",
      omschrijving: "Bonen, veld- (onder andere duiven-, paarden-, wierbonen) ",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1861,
      code: "3806",
      omschrijving: "Boomkwekerijgewassen en vaste planten, open grond",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1842,
      code: "294",
      omschrijving:
        "Boomkwekerijgewassen en vaste planten, pot- en containerveld",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1554,
      code: "2717",
      omschrijving: "Bospeen, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1555,
      code: "2718",
      omschrijving: "Bospeen, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1815,
      code: "2026",
      omschrijving: "Braak, met bos (SBL-regeling na 28 juni 1995)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1817,
      code: "2029",
      omschrijving: "Braak, natuur",
      bcid: 3,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1513,
      code: "2327",
      omschrijving: "Bramen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1687,
      code: "654",
      omschrijving: "Brandnetel",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1556,
      code: "2719",
      omschrijving: "Broccoli, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1557,
      code: "2720",
      omschrijving: "Brocolli, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1454,
      code: "1068",
      omschrijving: "Buxus, open grond,",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1558,
      code: "2721",
      omschrijving: "Chinese kool, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1559,
      code: "2722",
      omschrijving: "Chinese kool, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1791,
      code: "1041",
      omschrijving: "Chrysant, bloembollen en -knollen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1790,
      code: "1040",
      omschrijving: "Chrysant, droogbloemen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1789,
      code: "1039",
      omschrijving: "Chrysant, overige bloemkwekerijgewassen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1805,
      code: "1055",
      omschrijving: "Chrysant, vermeerdering",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1682,
      code: "511",
      omschrijving: "Cichorei",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1560,
      code: "2723",
      omschrijving: "Courgette, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1561,
      code: "2724",
      omschrijving: "Courgette, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1797,
      code: "1047",
      omschrijving: "Cranberry",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1734,
      code: "997",
      omschrijving: "Dahlia, bloembollen en - knollen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1713,
      code: "965",
      omschrijving: "Dahlia, droogbloemen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1712,
      code: "964",
      omschrijving: "Dahlia, overige bloemkwekerijgewassen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1652,
      code: "3505",
      omschrijving: "Deder",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1867,
      code: "657",
      omschrijving: "Drachtplanten",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1798,
      code: "1048",
      omschrijving: "Echinacea (zonnehoed), productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1799,
      code: "1049",
      omschrijving: "Echinacea (zonnehoed), zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1653,
      code: "3506",
      omschrijving: "Engels raaigras",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1455,
      code: "1069",
      omschrijving:
        "Ericaceae (Zoals erica, calluna, rododendron, azalea), open grond,",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1469,
      code: "1083",
      omschrijving:
        "Ericaceae (Zoals erica, calluna, rododendron, azalea), pot- en containerveld,",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1632,
      code: "308",
      omschrijving: "Erwten (droog te oogsten)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1831,
      code: "2650",
      omschrijving: "Erwten inclusief schokkers (droog te oogsten)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1523,
      code: "244",
      omschrijving: "Erwten, groene/gele (groen te oogsten)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1702,
      code: "801",
      omschrijving: "Esparcette",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1654,
      code: "3507",
      omschrijving: "Ethiopische mosterd",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1655,
      code: "3508",
      omschrijving: "Facelia",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1850,
      code: "3721",
      omschrijving: "Faunaranden, bouwland",
      bcid: 3,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1849,
      code: "3720",
      omschrijving: "Faunaranden, grasland",
      bcid: 3,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1656,
      code: "3509",
      omschrijving: "Festulolium",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1512,
      code: "2326",
      omschrijving: "Frambozen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1657,
      code: "3510",
      omschrijving: "Franse boekweit",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1818,
      code: "212",
      omschrijving: "Fruit",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1681,
      code: "428",
      omschrijving: "Gele mosterd",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1517,
      code: "235",
      omschrijving: "Gerst, winter-",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1518,
      code: "236",
      omschrijving: "Gerst, zomer-",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1735,
      code: "998",
      omschrijving: "Gladiool, bloembollen en - knollen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1715,
      code: "968",
      omschrijving: "Gladiool, droogbloemen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1714,
      code: "967",
      omschrijving: "Gladiool, overige bloemkwekerijgewassen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1782,
      code: "1032",
      omschrijving: "Goudsbloem",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1534,
      code: "265",
      omschrijving: "Grasland, blijvend",
      bcid: 4,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1847,
      code: "3718",
      omschrijving: "Grasland, natuurlijk",
      bcid: 3,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1844,
      code: "336",
      omschrijving:
        "Grasland, natuurlijk. Areaal dat overwegend voor landbouwactiviteiten-GLB wordt gebruikt.",
      bcid: 3,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1637,
      code: "331",
      omschrijving: "Grasland, natuurlijk. Hoofdfunctie landbouw.",
      bcid: 4,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1638,
      code: "332",
      omschrijving: "Grasland, natuurlijk. Hoofdfunctie natuur.",
      bcid: 3,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1536,
      code: "266",
      omschrijving: "Grasland, tijdelijk",
      bcid: 4,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1678,
      code: "383",
      omschrijving: "Graszaad",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1833,
      code: "2653",
      omschrijving: "Graszaad (inclusief klaverzaad)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1495,
      code: "1921",
      omschrijving: "Graszoden",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1821,
      code: "2299",
      omschrijving: "Groenbemesters, niet-vlinderbloemige-",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1820,
      code: "2298",
      omschrijving: "Groenbemesters, vlinderbloemige-",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1868,
      code: "672",
      omschrijving: "Groenten open grond (inclusief groentezaden)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1520,
      code: "238",
      omschrijving: "Haver",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1848,
      code: "3719",
      omschrijving: "Heide",
      bcid: 3,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1711,
      code: "944",
      omschrijving: "Hennep, vezel-",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1745,
      code: "2628",
      omschrijving: "Hoogstamboomgaard",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1675,
      code: "375",
      omschrijving: "Hop",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1736,
      code: "1.51",
      omschrijving: "Hyacint, bloembollen en - knollen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1717,
      code: "971",
      omschrijving: "Hyacint, droogbloemen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1716,
      code: "970",
      omschrijving: "Hyacint, overige bloemkwekerijgewassen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1783,
      code: "1033",
      omschrijving: "Igniscum Candy",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1445,
      code: "1000",
      omschrijving: "Iris, bloembollen en -knollen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1801,
      code: "1051",
      omschrijving: "Iris, Bolvormend",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1719,
      code: "974",
      omschrijving: "Iris, droogbloemen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1718,
      code: "973",
      omschrijving: "Iris, overige bloemkwekerijgewassen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1802,
      code: "1052",
      omschrijving: "Iris, Rhizoomvormend",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1659,
      code: "3512",
      omschrijving: "Italiaans raaigras",
      bcid: 4,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1695,
      code: "670",
      omschrijving: "Japanse haver",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1784,
      code: "1034",
      omschrijving: "Kanariezaad",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1521,
      code: "241",
      omschrijving: "Kapucijners (en grauwe erwten)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1524,
      code: "246",
      omschrijving: "Karwijzaad (oogst dit jaar)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1514,
      code: "2328",
      omschrijving: "Kersen, zoet",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1491,
      code: "1872",
      omschrijving:
        "Kersen, zuur (opbrengst bestemd voor verwerkende industrie)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1699,
      code: "796",
      omschrijving: "Kerstbomen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1647,
      code: "3500",
      omschrijving: "Klaver, Alexandrijnse",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1658,
      code: "3511",
      omschrijving: "Klaver, incarnaat",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1662,
      code: "3515",
      omschrijving: "Klaver, Perzische",
      bcid: 4,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1700,
      code: "799",
      omschrijving: "Klaver, rode",
      bcid: 4,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1671,
      code: "3524",
      omschrijving: "Klaver, witte",
      bcid: 4,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1705,
      code: "804",
      omschrijving: "Klaverzaad",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1771,
      code: "1021",
      omschrijving: "Knoflook",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1562,
      code: "2725",
      omschrijving: "Knolselderij, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1563,
      code: "2726",
      omschrijving: "Knolselderij, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1564,
      code: "2727",
      omschrijving: "Knolvenkel/venkel, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1565,
      code: "2728",
      omschrijving: "Knolvenkel/venkel, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1566,
      code: "2729",
      omschrijving: "Komkommer, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1567,
      code: "2730",
      omschrijving: "Komkommer, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1574,
      code: "2737",
      omschrijving: "Koolraap, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1575,
      code: "2738",
      omschrijving: "Koolraap, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1576,
      code: "2739",
      omschrijving: "Koolrabi, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1577,
      code: "2740",
      omschrijving: "Koolrabi, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1496,
      code: "1922",
      omschrijving: "Koolzaad, winter (incl. boterzaad)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1497,
      code: "1923",
      omschrijving: "Koolzaad, zomer (incl. boterzaad)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1446,
      code: "1001",
      omschrijving: "Krokus, bloembollen en - knollen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1721,
      code: "977",
      omschrijving: "Krokus, droogbloemen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1720,
      code: "976",
      omschrijving: "Krokus, overige bloemkwekerijgewassen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1578,
      code: "2741",
      omschrijving: "Kroten/rode bieten, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1579,
      code: "2742",
      omschrijving: "Kroten/rode bieten, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1580,
      code: "2743",
      omschrijving: "Kruiden, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1581,
      code: "2744",
      omschrijving: "Kruiden, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1768,
      code: "1018",
      omschrijving: "Kuifhyacint, bloembollen en -knollen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1767,
      code: "1017",
      omschrijving: "Kuifhyacint, droogbloemen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1766,
      code: "1016",
      omschrijving: "Kuifhyacint, overige bloemkwekerijgewassen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1456,
      code: "1070",
      omschrijving: "Laanbomen/parkbomen, onderstammen, open grond,",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1457,
      code: "1071",
      omschrijving: "Laanbomen/parkbomen, opzetters, open grond,",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1458,
      code: "1072",
      omschrijving: "Laanbomen/parkbomen, spillen, open grond,",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1778,
      code: "1028",
      omschrijving: "Lavas (Maggiplant), productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1779,
      code: "1029",
      omschrijving: "Lavas (Maggiplant), zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1800,
      code: "1050",
      omschrijving: "Leeuwenbekjes",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1447,
      code: "1002",
      omschrijving: "Lelie, bloembollen en -knollen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1723,
      code: "980",
      omschrijving: "Lelie, droogbloemen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1722,
      code: "979",
      omschrijving: "Lelie, overige bloemkwekerijgewassen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1690,
      code: "663",
      omschrijving: "Lupinen, niet bittere",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1528,
      code: "258",
      omschrijving: "Luzerne",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1636,
      code: "317",
      omschrijving: "Maïs, corncob mix",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1508,
      code: "2032",
      omschrijving: "Maïs, energie-",
      bcid: 1,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1635,
      code: "316",
      omschrijving: "Maïs, korrel-",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1529,
      code: "259",
      omschrijving: "Maïs, snij-",
      bcid: 1,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1706,
      code: "814",
      omschrijving: "Maïs, suiker-",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1814,
      code: "1935",
      omschrijving: "Maiskolvensilage",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1685,
      code: "652",
      omschrijving: "Meekrap",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1570,
      code: "2733",
      omschrijving: "Meloen, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1571,
      code: "2734",
      omschrijving: "Meloen, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1684,
      code: "516",
      omschrijving: "Miscanthus (olifantsgras)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1785,
      code: "1035",
      omschrijving: "Naaldaar (Setaria)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1448,
      code: "1003",
      omschrijving: "Narcis, bloembollen en -knollen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1725,
      code: "983",
      omschrijving: "Narcis, droogbloemen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1724,
      code: "982",
      omschrijving: "Narcis, overige bloemkwekerijgewassen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1641,
      code: "335",
      omschrijving: "Natuurterreinen (incl. heide)",
      bcid: 3,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1661,
      code: "3514",
      omschrijving: "Niger",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1533,
      code: "2645",
      omschrijving: "Notenbomen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1509,
      code: "2033",
      omschrijving: "Onbeteelde grond, tijdelijk",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1493,
      code: "1874",
      omschrijving: "Overig kleinfruit (zoals kruisbessen, kiwi's)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1498,
      code: "1925",
      omschrijving: "Overige akkerbouwgewassen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1809,
      code: "1927",
      omschrijving: "Overige akkerbouwgewassen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1451,
      code: "1006",
      omschrijving: "Overige bloemen, bloembollen en -knollen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1731,
      code: "992",
      omschrijving: "Overige bloemen, droogbloemen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1730,
      code: "991",
      omschrijving: "Overige bloemen, overige bloemkwekerijgewassen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1535,
      code: "2652",
      omschrijving: "Overige granen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1680,
      code: "427",
      omschrijving: "Overige groenbemesters, niet-vlinderbloemige-",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1679,
      code: "426",
      omschrijving: "Overige groenbemesters, vlinderbloemige- ",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1851,
      code: "3722",
      omschrijving: "Overige natuurterreinen",
      bcid: 3,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1628,
      code: "2791",
      omschrijving: "Overige niet genoemde bladgewassen, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1629,
      code: "2792",
      omschrijving:
        "Overige niet genoemde bladgewassen, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1630,
      code: "2793",
      omschrijving: "Overige niet genoemde groenten, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1631,
      code: "2794",
      omschrijving: "Overige niet genoemde groenten, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1486,
      code: "1100",
      omschrijving:
        "Overige pit- en steenvruchten (zoals perziken, tafeldruiven)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1582,
      code: "2745",
      omschrijving: "Paksoi, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1583,
      code: "2746",
      omschrijving: "Paksoi, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1794,
      code: "1044",
      omschrijving: "Papaver",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1773,
      code: "1023",
      omschrijving: "Pastinaak, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1774,
      code: "1024",
      omschrijving: "Pastinaak, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1483,
      code: "1097",
      omschrijving: "Peren. Aangeplant lopende seizoen.",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1484,
      code: "1098",
      omschrijving: "Peren. Aangeplant voorafgaande aan lopende seizoen.",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1787,
      code: "1037",
      omschrijving: "Peterselie, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1788,
      code: "1038",
      omschrijving: "Peterselie, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1584,
      code: "2747",
      omschrijving: "Peulen, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1585,
      code: "2748",
      omschrijving: "Peulen, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1777,
      code: "1027",
      omschrijving: "Pioenroos, bloembollen en -knollen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1776,
      code: "1026",
      omschrijving: "Pioenroos, droogbloemen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1775,
      code: "1025",
      omschrijving: "Pioenroos, overige bloemkwekerijgewassen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1804,
      code: "1054",
      omschrijving: "Pioenroos, vermeerdering",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1572,
      code: "2735",
      omschrijving: "Pompoen, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1573,
      code: "2736",
      omschrijving: "Pompoen, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1586,
      code: "2749",
      omschrijving: "Prei, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1838,
      code: "2799",
      omschrijving: "Prei, winter, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1839,
      code: "2800",
      omschrijving: "Prei, winter, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1587,
      code: "2750",
      omschrijving: "Prei, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1840,
      code: "2801",
      omschrijving: "Prei, zomer, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1841,
      code: "2802",
      omschrijving: "Prei, zomer, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1588,
      code: "2751",
      omschrijving: "Pronkbonen, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1589,
      code: "2752",
      omschrijving: "Pronkbonen, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1490,
      code: "1870",
      omschrijving: "Pruimen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1772,
      code: "1022",
      omschrijving: "Quinoa",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1590,
      code: "2753",
      omschrijving: "Raapstelen, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1591,
      code: "2754",
      omschrijving: "Raapstelen, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1691,
      code: "664",
      omschrijving: "Raapzaad",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1592,
      code: "2755",
      omschrijving: "Rabarber, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1593,
      code: "2756",
      omschrijving: "Rabarber, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1594,
      code: "2757",
      omschrijving: "Radijs, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1595,
      code: "2758",
      omschrijving: "Radijs, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1696,
      code: "671",
      omschrijving: "Raketblad (aaltjesvanggewas)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1639,
      code: "333",
      omschrijving:
        "Rand, grenzend aan blijvend grasland of een blijvende teelt, hoofdzakelijk bestaand uit blijvend gras",
      bcid: 4,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1643,
      code: "344",
      omschrijving:
        "Rand, grenzend aan blijvend grasland of een blijvende teelt, hoofdzakelijk bestaand uit een ander gewas dan gras",
      bcid: 4,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1672,
      code: "370",
      omschrijving:
        "Rand, grenzend aan blijvend grasland of een blijvende teelt, hoofdzakelijk bestaand uit tijdelijk gras",
      bcid: 4,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1640,
      code: "334",
      omschrijving:
        "Rand, grenzend aan bouwland, hoofdzakelijk bestaand uit blijvend gras",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1644,
      code: "345",
      omschrijving:
        "Rand, grenzend aan bouwland, hoofdzakelijk bestaand uit een ander gewas dan gras",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1858,
      code: "3803",
      omschrijving:
        "Rand, grenzend aan bouwland, hoofdzakelijk bestaand uit een ander gewas dan gras. (EA: beheer)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1859,
      code: "3804",
      omschrijving:
        "Rand, grenzend aan bouwland, hoofdzakelijk bestaand uit een ander gewas dan gras. (EA: onbeheerd)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1673,
      code: "372",
      omschrijving:
        "Rand, grenzend aan bouwland, hoofdzakelijk bestaand uit tijdelijk gras",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1846,
      code: "338",
      omschrijving:
        "Rand, liggend op bouwland en direct grenzend aan bos. Geen landbouwproductie.",
      bcid: 3,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1663,
      code: "3516",
      omschrijving: "Rietzwenkgras",
      bcid: 4,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1862,
      code: "3807",
      omschrijving: "Rietzwenkgras, anders dan voor industriegras",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1860,
      code: "3805",
      omschrijving: "Rietzwenkgras, industriegras",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1596,
      code: "2759",
      omschrijving: "Rodekool, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1597,
      code: "2760",
      omschrijving: "Rodekool, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1519,
      code: "237",
      omschrijving: "Rogge (geen snijrogge)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1701,
      code: "800",
      omschrijving: "Rolklaver",
      bcid: 4,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1863,
      code: "3808",
      omschrijving: "Roodzwenkgras",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1459,
      code: "1073",
      omschrijving:
        "Rozenstruiken (incl, zaailingen en onderstammen), open grond,",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1864,
      code: "636",
      omschrijving: "Saffloer",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1664,
      code: "3517",
      omschrijving: "Sarepta mosterd/Caliente",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1598,
      code: "2761",
      omschrijving: "Savooiekool, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1599,
      code: "2762",
      omschrijving: "Savooiekool, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1601,
      code: "2764",
      omschrijving: "Schorseneren, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1600,
      code: "2763",
      omschrijving: "Schorseneren; productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1602,
      code: "2765",
      omschrijving: "Selderij, bleek- en groen-, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1603,
      code: "2766",
      omschrijving: "Selderij, bleek- en groen-, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1665,
      code: "3518",
      omschrijving: "Seradelle",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1460,
      code: "1074",
      omschrijving: "Sierconiferen, open grond,",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1461,
      code: "1075",
      omschrijving: "Sierheesters en klimplanten, open grond,",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1762,
      code: "1012",
      omschrijving: "Sierui, bloembollen en -knollen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1761,
      code: "1011",
      omschrijving: "Sierui, droogbloemen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1760,
      code: "1010",
      omschrijving: "Sierui, overige bloemkwekerijgewassen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1813,
      code: "1934",
      omschrijving: "Sjalotten",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1604,
      code: "2767",
      omschrijving: "Sla, ijsberg-, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1605,
      code: "2768",
      omschrijving: "Sla, ijsberg-, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1608,
      code: "2771",
      omschrijving: "Sla; overig, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1609,
      code: "2772",
      omschrijving: "Sla; overig, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1606,
      code: "2769",
      omschrijving: "Sla; radicchio rosso, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1607,
      code: "2770",
      omschrijving: "Sla; radicchio rosso, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1494,
      code: "1876",
      omschrijving: "Snijgroen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1666,
      code: "3519",
      omschrijving: "Soedangras/Sorghum",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1692,
      code: "665",
      omschrijving: "Sojabonen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1677,
      code: "382",
      omschrijving: "Spelt",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1610,
      code: "2773",
      omschrijving: "Spinazie, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1611,
      code: "2774",
      omschrijving: "Spinazie, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1612,
      code: "2775",
      omschrijving: "Spitskool, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1613,
      code: "2776",
      omschrijving: "Spitskool, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1614,
      code: "2777",
      omschrijving: "Spruitkool/spruitjes, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1615,
      code: "2778",
      omschrijving: "Spruitkool/spruitjes, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1667,
      code: "3520",
      omschrijving: "Spurrie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1616,
      code: "2779",
      omschrijving: "Stamsperziebonen (=stamslabonen), productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1617,
      code: "2780",
      omschrijving:
        "Stamsperziebonen (=stamslabonen), zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1618,
      code: "2781",
      omschrijving: "Stoksnijbonen en stokslabonen, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1619,
      code: "2782",
      omschrijving: "Stoksnijbonen en stokslabonen, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1668,
      code: "3521",
      omschrijving: "Stoppelknollen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1810,
      code: "1930",
      omschrijving: "Tagetes (zand, löss) (geen groene braak)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1645,
      code: "346",
      omschrijving: "Tagetes erecta (Afrikaantje)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1646,
      code: "347",
      omschrijving: "Tagetes patula (Afrikaantje)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1515,
      code: "233",
      omschrijving: "Tarwe, winter-",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1516,
      code: "234",
      omschrijving: "Tarwe, zomer-",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1676,
      code: "381",
      omschrijving: "Teff",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1686,
      code: "653",
      omschrijving: "Teunisbloem",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1669,
      code: "3522",
      omschrijving: "Timothee",
      bcid: 4,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1462,
      code: "1076",
      omschrijving: "Trek- en besheesters, open grond,",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1634,
      code: "314",
      omschrijving: "Triticale",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1449,
      code: "1004",
      omschrijving: "Tulp, bloembollen en -knollen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1727,
      code: "986",
      omschrijving: "Tulp, droogbloemen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1726,
      code: "985",
      omschrijving: "Tulp, overige bloemkwekerijgewassen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1499,
      code: "1931",
      omschrijving: "Uien, poot- en plant- (incl. sjalotten)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1811,
      code: "1932",
      omschrijving: "Uien, poot en plant, 1e jaars",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1812,
      code: "1933",
      omschrijving: "Uien, poot en plant, 2e jaars",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1530,
      code: "262",
      omschrijving: "Uien, zaai-",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1531,
      code: "263",
      omschrijving: "Uien, zilver-",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1769,
      code: "1019",
      omschrijving: "Valeriaan, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1770,
      code: "1020",
      omschrijving: "Valeriaan, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1466,
      code: "1080",
      omschrijving: "Vaste planten, open grond,",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1670,
      code: "3523",
      omschrijving: "Veldbeemdgras",
      bcid: 4,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1796,
      code: "1046",
      omschrijving: "Vergeet mij nietje",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1693,
      code: "666",
      omschrijving: "Vlas, olie-. Lijnzaad niet van vezelvlas",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1674,
      code: "3736",
      omschrijving: "Vlas, vezel-",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1865,
      code: "637",
      omschrijving: "Vrouwenmantel",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1463,
      code: "1077",
      omschrijving: "Vruchtbomen, moerbomen, open grond,",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1464,
      code: "1078",
      omschrijving: "Vruchtbomen, onderstammen, open grond,",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1465,
      code: "1079",
      omschrijving: "Vruchtbomen, overig, open grond,",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1620,
      code: "2783",
      omschrijving: "Waspeen, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1621,
      code: "2784",
      omschrijving: "Waspeen, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1660,
      code: "3513",
      omschrijving: "Westerwolds raaigras",
      bcid: 4,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1485,
      code: "1099",
      omschrijving: "Wijndruiven",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1703,
      code: "802",
      omschrijving: "Wikke, bonte",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1704,
      code: "803",
      omschrijving: "Wikke, voeder-",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1780,
      code: "1030",
      omschrijving: "Wilde marjolein (Oregano), productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1781,
      code: "1031",
      omschrijving: "Wilde marjolein (Oregano), zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1622,
      code: "2785",
      omschrijving: "Winterpeen, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1623,
      code: "2786",
      omschrijving: "Winterpeen, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1624,
      code: "2787",
      omschrijving: "Witlofwortel, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1625,
      code: "2788",
      omschrijving: "Witlofwortel, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1626,
      code: "2789",
      omschrijving: "Witte kool, productie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1627,
      code: "2790",
      omschrijving: "Witte kool, zaden en opkweekmateriaal",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1786,
      code: "1036",
      omschrijving: "Wortelpeterselie",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1819,
      code: "2297",
      omschrijving: "Woudbomen met korte omlooptijd",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1450,
      code: "1005",
      omschrijving: "Zantedeschia, bloembollen en -knollen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1729,
      code: "989",
      omschrijving: "Zantedeschia, droogbloemen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1728,
      code: "988",
      omschrijving: "Zantedeschia, overige bloemkwekerijgewassen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1683,
      code: "515",
      omschrijving: "Zonnebloemen",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1866,
      code: "656",
      omschrijving: "Zonnekroon",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
    {
      gewascodeId: 1694,
      code: "669",
      omschrijving: "Zwaardherik (aaltjesvanggewas)",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: true,
    },
    {
      gewascodeId: 1688,
      code: "655",
      omschrijving: "Zwarte mosterd",
      bcid: 2,
      isDisabled: false,
      nietDoorrekenen: false,
    },
  ],
  gewaspercelen: [
    {
      bouwlandcategorieId: 4,
      doorrekenen: false,
      fixerend: true,
      geoogstGewas: [],
      gewascodeId: 1534,
      gewasPerceelId: "",
      grondsoortcategorieId: 1,
      grondwatertrap: "III",
      handmatig: true,
      isGemonsterd: false,
      klaverPercentage: 0,
      nlv: 0,
      oppervlakte: 10,
      pal: 5,
      perceelId: 9402,
      perceelNaam: "Bieten",
      ppae: 5,
      pw: 1,
      fosfaatklasseBepalingMethode: 1,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
      soc: 1.51,
      organischeStof: 36,
      lutum: 4.5,
      cnRatio: 40,
    },
    {
      bouwlandcategorieId: 4,
      doorrekenen: false,
      fixerend: true,
      geoogstGewas: [],
      gewascodeId: 1534,
      gewasPerceelId: "",
      grondsoortcategorieId: 2,
      grondwatertrap: "III",
      handmatig: true,
      isGemonsterd: false,
      klaverPercentage: 0,
      nlv: 0,
      oppervlakte: 30,
      pal: 6,
      perceelId: 9678,
      perceelNaam: "Bieten",
      ppae: 1,
      pw: 1,
      fosfaatklasseBepalingMethode: 1,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
      soc: 1.51,
      organischeStof: 36,
      lutum: 4.5,
      cnRatio: 40,
    },
    {
      bouwlandcategorieId: 4,
      doorrekenen: false,
      fixerend: true,
      geoogstGewas: [],
      gewascodeId: 1534,
      gewasPerceelId: "",
      grondsoortcategorieId: 2,
      grondwatertrap: "III",
      handmatig: true,
      isGemonsterd: false,
      klaverPercentage: 0,
      nlv: 0,
      oppervlakte: 1,
      pal: 6,
      perceelId: 10227,
      perceelNaam: "Bieten 10",
      ppae: 1,
      pw: 1,
      fosfaatklasseBepalingMethode: 1,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
      soc: 1.51,
      organischeStof: 36,
      lutum: 4.5,
      cnRatio: 40,
    },
    {
      bouwlandcategorieId: 4,
      doorrekenen: false,
      fixerend: true,
      geoogstGewas: [],
      gewascodeId: 1534,
      gewasPerceelId: "",
      grondsoortcategorieId: 2,
      grondwatertrap: "III",
      handmatig: true,
      isGemonsterd: false,
      klaverPercentage: 0,
      nlv: 0,
      oppervlakte: 15,
      pal: 6,
      perceelId: 9706,
      perceelNaam: "Bieten7",
      ppae: 1,
      pw: 1,
      fosfaatklasseBepalingMethode: 1,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
      soc: 1.51,
      organischeStof: 36,
      lutum: 4.5,
      cnRatio: 40,
    },
    {
      bouwlandcategorieId: 4,
      doorrekenen: false,
      fixerend: true,
      geoogstGewas: [],
      gewascodeId: 1534,
      gewasPerceelId: "",
      grondsoortcategorieId: 2,
      grondwatertrap: "III",
      handmatig: true,
      isGemonsterd: false,
      klaverPercentage: 0,
      nlv: 0,
      oppervlakte: 5,
      pal: 6,
      perceelId: 9707,
      perceelNaam: "Bieten8",
      ppae: 1,
      pw: 1,
      fosfaatklasseBepalingMethode: 1,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
      soc: 1.51,
      organischeStof: 36,
      lutum: 4.5,
      cnRatio: 40,
      cO2Emissie: 5,
      aandeelKustvlakteveenKaart: 56,
      moerigeOverlap: 44,
      isRegioSpecifiek: false
    },
    {
      bouwlandcategorieId: 4,
      doorrekenen: false,
      fixerend: true,
      geoogstGewas: [],
      gewascodeId: 1534,
      gewasPerceelId: "",
      grondsoortcategorieId: 2,
      grondwatertrap: "III",
      handmatig: true,
      isGemonsterd: false,
      klaverPercentage: 0,
      nlv: 0,
      oppervlakte: 1,
      pal: 6,
      perceelId: 9709,
      perceelNaam: "Bieten9",
      ppae: 1,
      pw: 1,
      fosfaatklasseBepalingMethode: 1,
      fosfaatklasseBepalingMethodeKiesbaar: false,
      magDoorgerekendWorden: true,
      soc: 1.51,
      organischeStof: 36,
      lutum: 4.5,
      cnRatio: 40,
      cO2Emissie: 5,
      aandeelKustvlakteveenKaart: 56,
      moerigeOverlap: 44,
      isRegioSpecifiek: false
    },
  ],
  fosfaattoestandCategorieen: [
    {
      id: 7,
      omschrijving: "Fosfaat ruim",
      minimalePalWaarde: 41,
      maximalePalWaarde: 50,
      minimalePwWaarde: 46,
      maximalePwWaarde: 55,
      fixerend: false,
      code: "ruim",
      palWaardenOmschrijving: "PAL-getal 41-50",
      pwWaardenOmschrijving: "PW-getal 46-55",
    },
    {
      id: 8,
      omschrijving: "Fosfaat hoog",
      minimalePalWaarde: 50,
      minimalePwWaarde: 55,
      fixerend: false,
      code: "hoog",
      palWaardenOmschrijving: "PAL-getal  > 50",
      pwWaardenOmschrijving: "PW-getal  > 55",
    },
    {
      id: 6,
      omschrijving: "Fosfaat neutraal",
      minimalePalWaarde: 27,
      maximalePalWaarde: 41,
      minimalePwWaarde: 36,
      maximalePwWaarde: 46,
      fixerend: false,
      code: "neutraal",
      palWaardenOmschrijving: "PAL-getal 27-41",
      pwWaardenOmschrijving: "PW-getal 36-46",
    },
    {
      id: 5,
      omschrijving: "Fosfaat laag",
      maximalePalWaarde: 27,
      maximalePwWaarde: 36,
      fixerend: false,
      code: "laag",
      palWaardenOmschrijving: "PAL-getal  < 27",
      pwWaardenOmschrijving: "PW-getal  < 36",
    },
    {
      id: 4,
      omschrijving: "Fosfaat arm",
      maximalePalWaarde: 16,
      maximalePwWaarde: 25,
      fixerend: true,
      code: "arm",
      palWaardenOmschrijving: "PAL-getal  < 16",
      pwWaardenOmschrijving: "PW-getal  < 25",
    },
  ],
  grond: {
    fosfaattoestandOppervlakten: [
      {
        fosfaattoestandCategorieId: 4,
        graslandOppervlakte: 500,
        natuurgraslandOppervlakte: 0,
        snijmaisOppervlakte: 0,
        akkerbouwOppervlakte: 0,
        omschrijving: "Fosfaat arm",
      },
      {
        fosfaattoestandCategorieId: 5,
        graslandOppervlakte: 20,
        natuurgraslandOppervlakte: 0,
        snijmaisOppervlakte: 10,
        akkerbouwOppervlakte: 0,
        omschrijving: "Fosfaat laag",
      },
      {
        fosfaattoestandCategorieId: 6,
        graslandOppervlakte: 500,
        natuurgraslandOppervlakte: 10,
        snijmaisOppervlakte: 0,
        akkerbouwOppervlakte: 0,
        omschrijving: "Fosfaat neutraal",
      },
      {
        fosfaattoestandCategorieId: 7,
        graslandOppervlakte: 0,
        natuurgraslandOppervlakte: 0,
        snijmaisOppervlakte: 0,
        akkerbouwOppervlakte: 10,
        omschrijving: "Fosfaat ruim",
      },
      {
        fosfaattoestandCategorieId: 8,
        graslandOppervlakte: 50,
        natuurgraslandOppervlakte: 0,
        snijmaisOppervlakte: 0,
        akkerbouwOppervlakte: 0,
        omschrijving: "Fosfaat hoog",
      },
    ],
  },
  bodemKoolstof: {
    bodemKoolstofToestanden: [
      {
        koolstofBodemCategorie: 8,
        graslandWaarde: 86.92,
        natuurgraslandWaarde: 0,
        snijmaisWaarde: 15.33,
        akkerbouwWaarde: 8.56,
        omschrijving: "Koolstof hoog",
      },
      {
        koolstofBodemCategorie: 7,
        graslandWaarde: 10,
        natuurgraslandWaarde: 0,
        snijmaisWaarde: 0,
        akkerbouwWaarde: 0,
        omschrijving: "Koolstof ruim",
      },
      {
        koolstofBodemCategorie: 6,
        graslandWaarde: 12.68,
        natuurgraslandWaarde: 20,
        snijmaisWaarde:30,
        akkerbouwWaarde: 1,
        omschrijving: "Koolstof neutraal",
      },
      {
        koolstofBodemCategorie: 5,
        graslandWaarde: 0,
        natuurgraslandWaarde: 0,
        snijmaisWaarde: 0,
        akkerbouwWaarde: 0,
        omschrijving: "Koolstof laag",
      },
      {
        koolstofBodemCategorie: 4,
        graslandWaarde: 57.94,
        natuurgraslandWaarde: 100,
        snijmaisWaarde: 0,
        akkerbouwWaarde: 0,
        omschrijving: "Koolstof arm",
      },
      {
        koolstofBodemCategorie: 3,
        graslandWaarde: 77,
        natuurgraslandWaarde: 0,
        snijmaisWaarde: 0,
        akkerbouwWaarde: 0,
        omschrijving: "Koolstof extra",
      },
      {
        koolstofBodemCategorie: 2,
        graslandWaarde: 88,
        natuurgraslandWaarde: 0,
        snijmaisWaarde: 0,
        akkerbouwWaarde: 0,
        omschrijving: "Koolstof extra2",
      },
      {
        koolstofBodemCategorie: 1,
        graslandWaarde: 99,
        natuurgraslandWaarde: 1,
        snijmaisWaarde: 0,
        akkerbouwWaarde: 0,
        omschrijving: "Koolstof extra3",
      },
    ],
  },
  grondEnBodemReadonly: true,
  grondsoorten: {
    verdelingGrondsoorten: [
      {
        grondsoortcategorieId: 1,
        omschrijving: "Aandeel veen",
        grasland: 50,
        natuurgrasland: 0,
        akkerbouw: 0,
        snijmaisland: 0,
      },
      {
        grondsoortcategorieId: 2,
        omschrijving: "Aandeel klei",
        grasland: 20,
        natuurgrasland: 0,
        akkerbouw: 0,
        snijmaisland: 0,
      },
      {
        grondsoortcategorieId: 3,
        omschrijving: "Aandeel zand, nat (II-V)",
        grasland: 500,
        natuurgrasland: 10,
        akkerbouw: 10,
        snijmaisland: 0,
      },
      {
        grondsoortcategorieId: 4,
        omschrijving: "Aandeel zand, matig droog (VI)",
        grasland: 500,
        natuurgrasland: 0,
        akkerbouw: 0,
        snijmaisland: 10,
      },
      {
        grondsoortcategorieId: 5,
        omschrijving: "Aandeel zand, droog (VII-VIII)",
        grasland: 0,
        natuurgrasland: 0,
        akkerbouw: 0,
        snijmaisland: 0,
      },
    ],
  },
  isAuthorized: true,
  kringloopwijzerId: 3602,
  kringloopwijzerJaar: 2021,
  kringloopwijzerStatus: 1,
  percelenVisible: true,
  isPpaeEnabled: true,
  kenmerkenMineralen: {
    kenmerkenMineralenGrondToestanden: [
      {
        bouwConWaarde: 0,
        bouwWisWaarde: 0,
        grasConWaarde: 0,
        grasWisWaarde: 0,
        kenmerkenMineralenGrondBodemCategorie: 8,
        natuurWaarde: 0,
        omschrijving: "C/N-ratio Monster"
      },
      {
        bouuwConWaarde: 28.47,
        bouwWisWaarde: 28.47,
        grasConWaarde: 57.75,
        grasWisWaarde: 57.75,
        kenmerkenMineralenGrondBodemCategorie: 7,
        natuurWaarde: 40.32,
        omschrijving: "Klei (Lutum) Monster"
      },
      {
        bouwConWaarde: 2.54,
        bouwWisWaarde: 2.54,
        grasConWaarde: 4.86,
        grasWisWaarde: 4.86,
        kenmerkenMineralenGrondBodemCategorie: 6,
        natuurWaarde: 4.42,
        omschrijving: "Koolstof (SOC) Monster"
      },
      {
        bouwConWaarde: 0,
        bouwWisWaarde: 0,
        grasConWaarde: 0,
        grasWisWaarde: 0,
        kenmerkenMineralenGrondBodemCategorie: 5,
        natuurWaarde: 0,
        omschrijving: "Organische stof Monster"
      },      
      {
        bouwConWaarde: 0,
        bouwWisWaarde: 0,
        grasConWaarde: 0,
        grasWisWaarde: 0,
        kenmerkenMineralenGrondBodemCategorie: 4,
        natuurWaarde: 0,
        omschrijving: "C/N-ratio Regio"
      },
      {
        bouuwConWaarde: 28.47,
        bouwWisWaarde: 28.47,
        grasConWaarde: 57.75,
        grasWisWaarde: 57.75,
        kenmerkenMineralenGrondBodemCategorie: 3,
        natuurWaarde: 40.32,
        omschrijving:"Klei (Lutum) Regio"
      },
      {
        bouwConWaarde: 0,
        bouwWisWaarde: 0,
        grasConWaarde: 0,
        grasWisWaarde: 0,
        kenmerkenMineralenGrondBodemCategorie: 2,
        natuurWaarde: 0,
        omschrijving:"Koolstof (SOC) Regio"
    },
    {
      bouwConWaarde: 12.54,
      bouwWisWaarde: 12.54,
      grasConWaarde: 14.86,
      grasWisWaarde: 8.86,
      kenmerkenMineralenGrondBodemCategorie: 1,
      natuurWaarde: 34.42,
      omschrijving:"Organische stof Regio"
    }
    ],
  },
  voorNaTeeltVanggewassen: {
    grasland: [
      {
        voorNaTeeltVanggewasId: 6,
        bouwlandCategorieId: 4,
        teeltTypeId: 4,
        grondgebruikTypeId: 3,
        gewascodeId: 0,
        oppervlakteInHa: 0,
        isOpgegeven: false,
        gewasGroepId: 5,
      },
      {
        voorNaTeeltVanggewasId: 7,
        bouwlandCategorieId: 4,
        teeltTypeId: 3,
        grondgebruikTypeId: 3,
        gewascodeId: 0,
        oppervlakteInHa: 0,
        isOpgegeven: false,
        gewasGroepId: 2,
      },
    ],
    snijmais: [
      {
        voorNaTeeltVanggewasId: 8,
        bouwlandCategorieId: 1,
        teeltTypeId: 3,
        grondgebruikTypeId: 3,
        gewascodeId: 0,
        oppervlakteInHa: 0,
        isOpgegeven: false,
        gewasGroepId: 9,
      },
    ],
    akkerbouw: [
      {
        voorNaTeeltVanggewasId: 9,
        bouwlandCategorieId: 2,
        teeltTypeId: 4,
        grondgebruikTypeId: 1,
        gewascodeId: 0,
        oppervlakteInHa: 0,
        isOpgegeven: false,
      },
    ],
  },
  teelttypes: [],
  gebruikKoppeltool: true,
  gebruikKoppeltoolKoolstofBodem: false,
  gebruikVanggewassen: false,
  bouwlandenTeeltTypesGrondgebruikTypes: [
    {
      bouwlandCategorie: {
        bouwlandCategorieId: 4,
        code: "PRODUCTIEGRAS",
        omschrijving: "Productiegrasland",
      },
      teeltTypes: [
        {
          teeltTypeId: 4,
          code: "NAGEWAS",
          omschrijving: "Nagewas",
          heeftGrondgebruikTypes: true,
        },
        {
          teeltTypeId: 3,
          code: "VOORGEWAS",
          omschrijving: "Voorgewas",
          heeftGrondgebruikTypes: true,
        },
      ],
      grondgebruikTypes: [
        {
          grondgebruikTypeId: 3,
          code: "AKKERBOUW",
          omschrijving: "Akkerbouw",
        },
        {
          grondgebruikTypeId: 2,
          code: "SNIJMAIS",
          omschrijving: "Snijmais",
        },
      ],
    },
    {
      bouwlandCategorie: {
        bouwlandCategorieId: 1,
        code: "SNIJMAIS",
        omschrijving: "Snijmaisland",
      },
      teeltTypes: [
        {
          teeltTypeId: 4,
          code: "NAGEWAS",
          omschrijving: "Nagewas",
          heeftGrondgebruikTypes: true,
        },
        {
          teeltTypeId: 2,
          code: "VANGNIETVLINDERB",
          omschrijving: "Vanggewas niet-vlinderbloemig (niet geoogst)",
          heeftGrondgebruikTypes: false,
        },
        {
          teeltTypeId: 1,
          code: "VANGVLINDERB",
          omschrijving: "Vanggewas vlinderbloemig (niet geoogst)",
          heeftGrondgebruikTypes: false,
        },
        {
          teeltTypeId: 3,
          code: "VOORGEWAS",
          omschrijving: "Voorgewas",
          heeftGrondgebruikTypes: true,
        },
      ],
      grondgebruikTypes: [
        {
          grondgebruikTypeId: 3,
          code: "AKKERBOUW",
          omschrijving: "Akkerbouw",
        },
        {
          grondgebruikTypeId: 1,
          code: "GRAS",
          omschrijving: "Gras",
        },
      ],
    },
    {
      bouwlandCategorie: {
        bouwlandCategorieId: 2,
        code: "OVERIG",
        omschrijving: "Akkerbouw",
      },
      teeltTypes: [
        {
          teeltTypeId: 4,
          code: "NAGEWAS",
          omschrijving: "Nagewas",
          heeftGrondgebruikTypes: true,
        },
        {
          teeltTypeId: 2,
          code: "VANGNIETVLINDERB",
          omschrijving: "Vanggewas niet-vlinderbloemig (niet geoogst)",
          heeftGrondgebruikTypes: false,
        },
        {
          teeltTypeId: 1,
          code: "VANGVLINDERB",
          omschrijving: "Vanggewas vlinderbloemig (niet geoogst)",
          heeftGrondgebruikTypes: false,
        },
        {
          teeltTypeId: 3,
          code: "VOORGEWAS",
          omschrijving: "Voorgewas",
          heeftGrondgebruikTypes: true,
        },
      ],
      grondgebruikTypes: [
        {
          grondgebruikTypeId: 1,
          code: "GRAS",
          omschrijving: "Gras",
        },
        {
          grondgebruikTypeId: 2,
          code: "SNIJMAIS",
          omschrijving: "Snijmais",
        },
      ],
    },
  ],
  gewasgroepen: [
    {
      gewasGroepId: 1,
      gewasGroepCode: "GPSGRANEN",
      omschrijving: "GPS-granen",
    },
    {
      gewasGroepId: 2,
      gewasGroepCode: "LUZERNE",
      omschrijving: "Luzerne",
    },
    {
      gewasGroepId: 3,
      gewasGroepCode: "RKLAVER",
      omschrijving: "Rode klaver",
    },
    {
      gewasGroepId: 4,
      gewasGroepCode: "BIETEN",
      omschrijving: "Bieten",
    },
    {
      gewasGroepId: 5,
      gewasGroepCode: "MAIS",
      omschrijving: "Mais (CCM, MKS)",
    },
    {
      gewasGroepId: 8,
      gewasGroepCode: "GRASZAAD",
      omschrijving: "Graszaad",
    },
    {
      gewasGroepId: 9,
      gewasGroepCode: "PEULVRUCHTEN",
      omschrijving: "Peulvruchten",
    },
    {
      gewasGroepId: 10,
      gewasGroepCode: "AARDAPPELEN",
      omschrijving: "Aardappelen",
    },
    {
      gewasGroepId: 11,
      gewasGroepCode: "POOTGOED",
      omschrijving: "Pootgoed",
    },
    {
      gewasGroepId: 12,
      gewasGroepCode: "UIBLOEMBOLLEN",
      omschrijving: "Uien en bloembollen",
    },
    {
      gewasGroepId: 13,
      gewasGroepCode: "BLADGROENTEN",
      omschrijving: "Groenten, blad",
    },
    {
      gewasGroepId: 14,
      gewasGroepCode: "NBLADGROENTEN",
      omschrijving: "Groenten, overig",
    },
    {
      gewasGroepId: 15,
      gewasGroepCode: "OVERIG",
      omschrijving: "Overige gewassen",
    },
    {
      gewasGroepId: 106,
      gewasGroepCode: "GRAANGEWASSEN",
      omschrijving: "Graangewassen",
    },
    {
      gewasGroepId: 107,
      gewasGroepCode: "ZAADGEWASSENOVERIG",
      omschrijving: "Zaadgewassen Overig",
    },
  ],
};
export type PercelenModel = typeof MOCK_PERCELEN;

export const getBodemPercelen = () =>
  klwAxios
    .get<PercelenModel>("/percelen/getpercelenmodel")
    .then((r) => r.data);

export const postBodemPercelen = (values: PercelenModel) =>
  klwAxios
    .post<PercelenModel>("/percelen/save", values)
    .then((r) => r.data);

mock.onGet("/percelen/getpercelenmodel").reply(200, MOCK_PERCELEN);
